import { Injectable }     from '@angular/core';

// Imports Angular
import { Component, OnInit, ViewEncapsulation, KeyValueDiffers, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {Location} from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

// Imports DIAN  
import { DContextoMuisca, DLogger } from '@dian/core';
import { DFormulario, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica, DDatosCompartidosCabecera  } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DRenta210v17Servicios, DObjetoEsResponsabilidad, DObjetoPagoPrimeraCuota, DRangosArt241ET, DDeclaracionSugerida } from '@dian-api/renta210v17';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DArchivoBlob, DDocumento, IDFormularioDocumento } from '@dian/api-formulario';
import { DRutServicios, DActividadesEconomicas } from '@dian/api-rut';
import { DActividadEconomica } from '@dian/api-rut/src/to/actividad-economica/dactividad-economica'; 
import { DDiligenciamientoParametricasServicios } from '@dian/api-diligenciamiento';
import { DPreguntasDialogoServicio } from '@dian-cmp/preguntas';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DFormularioServicio } from '@dian/api-formulario';
//import { DSugeridaNubeServicios } from '@dian-api/sugerida-nube';


import { DAniosFormato } from '@dian/api-formulario';
import { DPeriodoFormato } from '@dian/api-formulario';
import { DPeriodicidadFormato } from '@dian/api-formulario';
import { DLiquidacionRecibo } from '@dian-api/recibo-pago490';
import { DError } from '@dian/core';
import { DMarcasDocumento } from '@dian/api-formulario';
import { DRespuestaSimple } from '@dian/core';
import { DCorregible } from '@dian/api-formulario';
import { DExtemporaneo } from '@dian/api-formulario';
import { DIdentificadorFormulario } from '@dian/api-formulario';
import { DDocumentoAtributos } from '@dian/api-formulario';
 
import { DFirmaElectronica } from '@dian/api-formulario';
import { DMensajeParaFirmar } from '@dian/api-firma';
import { DGuardadoFirma } from '@dian/api-firma';
import { DFirmantesFormulario } from '@dian/api-formulario';

import { DFirmante } from '@dian/api-formulario';
import { DMensajeFirmado } from '@dian/api-firma';
import { DFirmaRealizada } from '@dian/api-firma';
import { DDilPersonaRutJSON } from '@dian-api/devoluciones';


// Imports App
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { timeout } from 'rxjs/operator/timeout';


import { DLiquidacionReciboExterior } from '@dian-api/recibo-pago490-exterior';
import { DReciboPagoExteriorDialogoServicio } from '@dian-cmp/recibo-pago490-exterior';
import { DProcesarInicializarDoc } from '@dian-cmp/formulario/src/implementaciones/dprocesar-inicializar-doc';


declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');  

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const MESSAGES = {
  FACTURA_NO_CORREGIBLE: "La Factura de Renta no puede ser corregida",
  DILIGENCIA_CAS24: "Para continuar, seleccione una actividad económica de la casilla 24.",
  ES_MAYOR: "Superó tope indicativo relativo al art. 336-1 del E.T. marque casilla 140",
  SUMATORIA_MAYOR_A_INGRESOS: "La sumatoria de los valores reportados en las preguntas no puede superar la suma de los ingresos (cas. 32 + cas. 43 + cas. 58 + cas. 74)",
  GENERO_OBLIGATORIO: "Diligencie el género seleccionando uno de los elementos en la lista de la casilla 286",
  TARIFA_DIVIDENDOS: "Señor Contribuyente: Para liquidar el impuesto de dividendos conforme al inciso 2 del artículo 242 del Estatuto Tributario diligencie una de las siguientes tarifas 0 %, 5 %, 9 %, 15 %, 27 %, 33 %, 35 %, 38 %, 40 %, 45 %, 50 %, 8.75 %, 17.5 % y 26.25 % que le aplicaron como retención en la fuente al momento del pago.",
  APORTE_VOLUNTARIO:"Su aporte voluntario se destinará para programas sociales de reducción de la pobreza extrema al igual que para programas de atención a las personas en condición de discapacidad física, priorizando así la población socioeconómica más vulnerable",
  PRESENTADO:"Estimado(a) ciudadano(a) <br><br>Gracias al pago de sus impuestos, el Estado puede financiar proyectos sociales y obras de infraestructura pública que nos benefician a todos.<br>Ratificamos nuestra intención de hacer de la DIAN una entidad más ágil, eficiente, cercana y moderna, que le ayude a cumplir, de mejor manera, sus obligaciones tributarias.<br>Juntos trabajamos para trasformar a Colombia.<br><br><b>Luis Carlos Reyes</b><br>Director General",
  DEPENDIENTE:"El dependiente asociado a la deducción del 10%, debe ser igual a uno de los agregados en las casillas 242,288,291 o 294"
};

/*
@Component({
  selector: 'app-formulario',
  encapsulation: ViewEncapsulation.None,
  providers: [
    DContextoUsuarioServicio,
    DNotificacionServicio,
    DPreguntasDialogoServicio,
    DOperacionesMatematicasServicio, 
    DUtilidadesFormularioServicio,       
    DRenta210v17Servicios,
    DRutServicios,
    DDiligenciamientoParametricasServicios,
    DBasicosParametricasServicios,
    DReciboPagoExteriorDialogoServicio,
    DReciboPagoDialogoServicio
  ]
})
*/

@Injectable()
export class Formulario210Servicio implements IDFormularioDocumento {
  

  @ViewChild('focusable124') cas214Element: ElementRef;

  //sliders
  private cardDeclarante: boolean = true;   
  private cardPreguntas: boolean = true;
  private cardPatrimonio: boolean = true;
  private cardRentasTrabajo: boolean = true;
  private cardRentashonorarios: boolean = true;
  private cardRentasCapital: boolean = true;
  private cardRentasNoLaborales: boolean = true;
  private cardCedulaGeneral: boolean = true;
  private cardRentasPensiones: boolean = true;
  private cardRentasDividendosParticipaciones: boolean = true;
  private cardGanaciaOcasional: boolean = true;
  private cardLiquidacionPrivada: boolean = true;
  private cardDependiente: boolean = true;
  private cardPagoTotal: boolean = true;
  private tipoDeclaracion : boolean = true;
  private booFraccion : boolean = false;
  private booCas108  : boolean = false;
  private booModifi2023 : boolean = false;
  private booTopeindicativo : boolean = false;

  public mostrarConsultarDeclaracionSugerida: boolean = false;
  public activacionDeclaracionSugerida: boolean = false;

  // Variables
  private UVT:string;
  private anioDeclaracion:number;
  private periodo:number;
  private parameters;
  private tiposDocumento: Array<DValorDominio>;
  private tiposDocumentofiltrado: Array<DValorDominio>;;
  private tiposParentesco;
  private listaGenero;
  //Declaración sugerida
  public listaDeclaracionSugerida: any;
  public declaracionSugerida: any;
  public declaracionSugeridaTO: any;
  private tienePrimeraCuota: DObjetoPagoPrimeraCuota;
  //casillas casillasDinamicas
  private casillasDinamicas: any; 
    //actividadesEconomicas
  private listaActividadesEconomicas:DActividadesEconomicas; 
  private listaActividadesEconomicasVigentes;
  //Rangos Articulo 241 Estatuto Tributario  
  private rangosArt241ET: any;
  private rangosArt241ETNumeral2: any;  
  private rangosArt241ETInciso1: any;
  private tabla1:any;  
  private tabla2:any;
  public esDecretoMocoa: boolean;
  private temporal41:string;
  private temporal53:string;
  private temporal69:string;
  private temporal86:string;
  private boolfinal = false;

  //Ayudas
  private ayudaCompletaDeclarante: boolean = false;
  private ayudaPreguntas: boolean = false;
  private ayudaPatrimonio: boolean = false;
  private ayudaRentasTrabajo: boolean = false;
  private ayudaRentasCapital: boolean = false;
  private ayudaRentasHonorarios: boolean = false;
  private ayudaRentasNoLaborales: boolean = false;
  private ayudaCedulaGeneral: boolean = false;
  private ayudaRentasPensiones: boolean = false;
  private ayudaRentasDividendosParticipaciones: boolean = false;
  private ayudaGananciaOcasional: boolean = false;
  private ayudaLiquidacionPrivada: boolean = false;
  private ayudaFirmas: boolean = false;
  private ayudaPagoTotal: boolean = false;
  
  private cambioFirma: boolean = true;
  private contador : Number = 0;

  private tarifaA: string;
  private tarifaB: string;
  private strDividendosOtros: string;
  private porcDividendos = ['0', '5', '9', '15', '27', '33', '35', '38', '40', '45', '50', '8.75', '17.5', '26.25'];

  private calcularCas121:boolean = true;
  public mensajeIconoSugerida : string = 'Consultar Declaración sugerida';
  private modelo: DDocumento=new DDocumento();
  //protected dNotificacionServicio: DNotificacionServicio;
  private dBasicosParametricasServicios:DBasicosParametricasServicios;
  private dServicioRESTAPI:DRenta210v17Servicios;
  private dRutServicios:DRutServicios;  
  dutilidades:DOperacionesMatematicasServicio=new DOperacionesMatematicasServicio();
  utilitariosForm:DUtilidadesFormularioServicio;
  private dProcesarInicializarDoc: DProcesarInicializarDoc; 
  totalIngresos = '';
  private cuentadependientes:number=0;

  habilitaDependiente2: boolean = true;
  habilitaDependiente3: boolean = true;
  habilitaDependiente4: boolean = true;
  habilitaDependiente5: boolean = true;
  


  ///////////////////////////////////////////////////////////////////////////
private idEndPoint:string;
private pathConfiguracion:string;
constructor (
  private dFormularioServicio:DFormularioServicio, 
  private dNotificacionServicio: DNotificacionServicio,
  //private _restSugeridaNube:DSugeridaNubeServicios
  ) {
  this.idEndPoint = 'Renta210v17';
  this.pathConfiguracion = './assets/@dian-api/renta210v17/configuracion';
    //this.dFormularioServicio.setPathConfiguracion(this.pathConfiguracion );
}

    
public crearFormulario(documento:DDocumento, modo: string): Observable<DDocumento|DMarcasDocumento|DError>{
    return this.dFormularioServicio.crearFormulario(documento,modo,this.idEndPoint,this.pathConfiguracion);
}   
public obtenerBorradorInicial(anio:number,periodicidad:string,periodo:number,modo:string):Observable<DDocumento|DError>{
    return this.dFormularioServicio.obtenerBorradorInicial(anio,periodicidad,periodo,modo,this.idEndPoint,this.pathConfiguracion);
}
public obtenerBorradorCorreccion(anio:number,periodicidad:string,periodo:number,doccorregir:string):Observable<DDocumento|DError>{
    return this.dFormularioServicio.obtenerBorradorCorreccion(anio,periodicidad,periodo,doccorregir,this.idEndPoint,this.pathConfiguracion);
}       
public obtenerBorradorInicialFraccion(anio:number,periodicidad:string,periodo:number):Observable<DDocumento|DError>{
    return this.dFormularioServicio.obtenerBorradorInicialFraccion(anio,periodicidad,periodo,this.idEndPoint,this.pathConfiguracion);
}    
public obtenerBorradorCorreccionFraccion(anio:number,periodicidad:string,periodo:number,doccorregir:string):Observable<DDocumento|DError>{
    return this.dFormularioServicio.obtenerBorradorCorreccionFraccion(anio,periodicidad,periodo,doccorregir,this.idEndPoint,this.pathConfiguracion);
}
public obtenerBorradoresIniciales(anio:number,periodicidad:string,periodo:number):Observable<Array<DDocumento>|DError>{
    return this.dFormularioServicio.obtenerBorradoresIniciales(anio,periodicidad,periodo,this.idEndPoint,this.pathConfiguracion);
}
public obtenerBorradoresCorrecciones(anio:number,periodicidad:string,periodo:number,doccorregir:string):Observable<Array<DDocumento>|DError>{
    return this.dFormularioServicio.obtenerBorradoresCorrecciones(anio,periodicidad,periodo,doccorregir,this.idEndPoint,this.pathConfiguracion)
}    
public obtenerBorradoresInicialesFraccion(anio:number,periodicidad:string,periodo:number):Observable<Array<DDocumento>|DError>{
    return this.dFormularioServicio.obtenerBorradoresInicialesFraccion(anio,periodicidad,periodo,this.idEndPoint,this.pathConfiguracion);
}
public obtenerBorradoresCorreccionesFraccion(anio:number,periodicidad:string,periodo:number,doccorregir:string):Observable<Array<DDocumento>|DError>{
    return this.dFormularioServicio.obtenerBorradoresCorreccionesFraccion(anio,periodicidad,periodo,doccorregir,this.idEndPoint,this.pathConfiguracion);
}
public clonarDocumentoDefinitivo(ideDocumento:string,anio:number,modo:string,periodicidad:string,periodo:number): Observable<DDocumento|DError>{
    return this.dFormularioServicio.clonarDocumentoDefinitivo(ideDocumento,anio,modo,periodicidad,periodo,this.idEndPoint,this.pathConfiguracion);
}
public consultarFormulario(ideDocumento:string): Observable<DDocumento|DError>{
    return this.dFormularioServicio.consultarFormulario(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public actualizarFormulario(ideDocumento:string,formulario:DDocumento, modo: string): Observable<DDocumento|DMarcasDocumento|DError>{
    return this.dFormularioServicio.actualizarFormulario(ideDocumento,formulario,modo,this.idEndPoint,this.pathConfiguracion);
}   
public esExtemporaneo(ideDocumento:string): Observable<DExtemporaneo|DError>{
    return this.dFormularioServicio.esExtemporaneo(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public esCorregible(ideDocumento:string): Observable<DCorregible|DError>{
    return this.dFormularioServicio.esCorregible(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public descargarFormulario(ideDocumento:string): Observable<DRespuestaSimple|DError>{
    return this.dFormularioServicio.descargarFormulario(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public presentarFormulario(ideDocumento:string): Observable<DRespuestaSimple|DError>{
    return this.dFormularioServicio.presentarFormulario(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public formularioDefinitivo(ideDocumento:string,documento:DDocumento): Observable<DRespuestaSimple|DError>{
    return this.dFormularioServicio.formularioDefinitivo(ideDocumento,documento,this.idEndPoint,this.pathConfiguracion);
}
public liquidarFormulario(ideDocumento:string): Observable<DIdentificadorFormulario|DError>{
    return this.dFormularioServicio.liquidarFormulario(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public validarInformacionFormulario(ideDocumento:string): Observable<DMarcasDocumento|DError>{
    return this.dFormularioServicio.validarInformacionFormulario(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public consultarFormularioAtributos(ideDocumento:string): Observable<DDocumentoAtributos|DError>{
    return this.dFormularioServicio.consultarFormularioAtributos(ideDocumento,this.idEndPoint,this.pathConfiguracion);
} 
public consultarFirmantes(ideDocumento:string): Observable<DFirmantesFormulario|DError>{
    return this.dFormularioServicio.consultarFirmantes(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public autorizarFirmante(ideDocumento:string,nit:string): Observable<DFirmante|DError>{
    return this.dFormularioServicio.autorizarFirmante(ideDocumento,nit,this.idEndPoint,this.pathConfiguracion);
}
public desautorizarFirmante(ideDocumento:string,nit:string): Observable<DFirmante|DError>{
    return this.dFormularioServicio.desautorizarFirmante(ideDocumento,nit,this.idEndPoint,this.pathConfiguracion);
}
public consultarFirmasRealizadas(ideDocumento:string,nit:string): Observable<DFirmaRealizada|DError>{
    return this.dFormularioServicio.consultarFirmasRealizadas(ideDocumento,nit,this.idEndPoint,this.pathConfiguracion);
}
public guardarFirmaFormulario(ideDocumento:string, dMensajeFirmado:DMensajeFirmado): Observable<DGuardadoFirma|DError>{
    return this.dFormularioServicio.guardarFirmaFormulario(ideDocumento, dMensajeFirmado,this.idEndPoint,this.pathConfiguracion);
}
public consultarMensajeFormularioFirma(ideDocumento:string): Observable<DMensajeParaFirmar|DError>{
    return this.dFormularioServicio.consultarMensajeFormularioFirma(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public esFirmanteElectronico(ideDocumento:string): Observable<DFirmaElectronica|DError>{
    return this.dFormularioServicio.esFirmanteElectronico(ideDocumento,this.idEndPoint,this.pathConfiguracion);
}
public consultarAniosFormato(): Observable<DAniosFormato|DError>{
    return this.dFormularioServicio.consultarAniosFormato(this.idEndPoint,this.pathConfiguracion);
}    
public consultarListaPeriodicidad(anio:number): Observable<DPeriodicidadFormato|DError>{
    return this.dFormularioServicio.consultarListaPeriodicidad(anio,this.idEndPoint,this.pathConfiguracion);
}    
public consultarListaPeriodos(anio:number,periodicidad:string): Observable<DPeriodoFormato|DError>{
    return this.dFormularioServicio.consultarListaPeriodos(anio,periodicidad,this.idEndPoint,this.pathConfiguracion);
}
public cargarSoportes(tipoDocumento: string, numIdentificacion:string, ideDocumento: string, listSoportes: Array<File>): Observable<Array<DArchivoBlob>|DError> {
    return this.dFormularioServicio.cargarSoportes(tipoDocumento, numIdentificacion, ideDocumento, listSoportes, this.idEndPoint, this.pathConfiguracion);
}
public descargarSoporte(ideObjeto:string, nit:string): Observable<DRespuestaSimple|DError>{
    return this.dFormularioServicio.descargarSoporte(ideObjeto,this.idEndPoint,this.pathConfiguracion);
}
public listarSoportes(ideDocumento:string): Observable<Array<DArchivoBlob>|DError> {
    return this.dFormularioServicio.listarSoportes(ideDocumento, this.idEndPoint, this.pathConfiguracion);
}

public generarLiquidacionReciboPago(ideDocumento: string, fecha?: string): Observable<DLiquidacionRecibo|DError> {
    return this.dFormularioServicio.generarLiquidacionReciboPago(ideDocumento, fecha, this.idEndPoint, this.pathConfiguracion);
}

public consultarNit(codigoUsuario:number): Observable< DDilPersonaRutJSON |DError>{
    return this.dFormularioServicio.consultarNit(codigoUsuario,this.idEndPoint,this.pathConfiguracion);
    
}
public eliminarSoporte(ideRadicado:string): Observable<DArchivoBlob|DError> {
  return this.dFormularioServicio.eliminarSoporte(ideRadicado, this.idEndPoint, this.pathConfiguracion);
}
///////////////////////////////////////////////////////////////////////////

  
  

  /**
  * @implements Funcion que comunica desde la clase padre que el documento se ha cargado correctamente
  */
  public onInitFormulario() {
   // Este metodo se ejecuta una vez la clase abstracta ha terminado su proceso y el formulario esta listo para ser diligenciado, aca se puede poner la logica que sea necesaria despues de que el formulario se encuentre listo
    this.anioDeclaracion = Number(this.modelo.doc.cab.cs_id_1);
    this.calcularTarifasAB();
    this.periodo = Number(this.modelo.doc.cab.cs_id_3);
    this.activacionDeclaracionSugerida = this.anioDeclaracion >= 2020;
    //Se castea la variable boolean de la casilla 994
    if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
      this.modelo.doc.pie['cs_id_994'] = false;
    } 
   
  
    
    //Servicios REST
    //Pago de primera cuota
    //Obtener UVT
    this.obtenerValorUVT(this.anioDeclaracion); //Al finalizar este servicio se llama a Obtener Actividades Economicas
    //let anioSiguiente = Number(this.anioDeclaracion) + 1;
    //Cambiar direccion seccional a Number
    let string_12 = this.modelo.doc.cab.cs_id_12;
    this.modelo.doc.cab.cs_id_12 = Number(string_12); 
    //obtener valores dominio
    this.obtenerTipoDocumento();
    this.obtenerTipoParentesco();
    this.obtenerListaGenero();
    //dissable 980 pago total
   
    this.temporal41 = this.modelo.doc.cuerpo.cs_id_41;
    this.temporal53 = this.modelo.doc.cuerpo.cs_id_53;
    this.temporal69 = this.modelo.doc.cuerpo.cs_id_69;
    this.temporal86 = this.modelo.doc.cuerpo.cs_id_86;

    if(!this.modelo.doc.cuerpo['cs_id_284']){ this.modelo.doc.cuerpo.cs_id_284 = "1";  }

    
      this.modelo.doc.cuerpo.cs_id_27 = "0";
    
    this.dividendosOtros(14);

  } 
  
 
  

  /**
  * @desc Funcion abstracta que comunica al hijo cuando se ha cargado uno o varios documentos cuando se usa el componente de cargar ficheros
  * @param {Any} docs
  */
  protected onUploadFiles(docs: Array<DArchivoBlob>){

  }

  // ====== Metodos creados por el desarrollador para operaciones con casillas y otras como (validacionesEnCampos, etc) ======

 

  private calcularTarifasAB(){
    let anio2020 =this.modelo.doc.cab.cs_id_1 == "2020";
    let anio2021 =this.modelo.doc.cab.cs_id_1 == "2021";
    let anio2022 =this.modelo.doc.cab.cs_id_1 == "2022";
    let fraccion= this.modelo.doc.cuerpo.cs_id_27 && (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == "true") 
    if (anio2020 && !fraccion){
        this.tarifaA = "0.32";
        this.tarifaB = "0.68";
    }else if(anio2020 && fraccion){
      this.tarifaA = "0.31";
      this.tarifaB = "0.69";
    }else if(anio2021 && !fraccion){
      this.tarifaA = "0.31";
      this.tarifaB = "0.69";
    }else  if(anio2021 && fraccion){
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    }else if(anio2022 && !fraccion){
    this.tarifaA = "0.35";
    this.tarifaB = "0.65";
    
    }else  if(anio2022 && fraccion){
     this.tarifaA = "0.35";
    }
  }

  private obtenerValorUVT(anioDeclaracion){
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    anioDeclaracion = (this.modelo.doc.cuerpo.cs_id_27 && (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == "true"))? Number(anioDeclaracion) + 1 : anioDeclaracion;
    this.dBasicosParametricasServicios.obtenerValorPeriodico(110,Number(anioDeclaracion)).subscribe( //110 es el codigo de UVT
      res=>{
          let valorPeriodico = <DValorPeriodico>res;
          this.UVT = String(valorPeriodico.valor);
          this.consultarActividadesVigentes();
            //esta validacion se incluyo por los cambios en las formulas de las casilla 272 y 270, dado que habia inconsistencias en los valores de los documentos guardados antes del cambio en las declaraciones iniciales
          
          precargaProceso.close();
        },error=>{
          precargaProceso.close();
        }
    );    
  }
  
  

  private obtenerTipoDocumento(){
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dBasicosParametricasServicios.obtenerValoresDominio("109").subscribe( //110 es el codigo de UVT
      res=>{
          this.tiposDocumento = <Array<DValorDominio>>res;
          this.filtrarTDocumento();
          precargaProceso.close();
        },error=>{
          precargaProceso.close();
        }
    );    
  }  

  private filtrarTDocumento(){
    let codigoDocumentos = ['11','12','13','14','21','22','31','32','41','42'];
    this.tiposDocumentofiltrado = new Array<DValorDominio>();
    for (let tipoDoc of this.tiposDocumento){
      if (codigoDocumentos.includes(tipoDoc.valor)) {
        this.tiposDocumentofiltrado.push(tipoDoc);
      }
      
    }
    this.tiposDocumentofiltrado.sort(function (a, b) {
      if (Number(a.valor) > Number(b.valor)) {
        return 1;
      }
      if (Number(a.valor) < Number(b.valor)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
  }
    

  private obtenerTipoParentesco(){
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dBasicosParametricasServicios.obtenerValoresDominio("1630").subscribe( //110 es el codigo de UVT
      res=>{
          this.tiposParentesco = <Array<DValorDominio>>res;
          precargaProceso.close();
        },error=>{
          precargaProceso.close();
        }
    );    
  }    
  private obtenerListaGenero(){
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dBasicosParametricasServicios.obtenerValoresDominio("1644", null,null,null,"codigo","asc").subscribe( 
      res=>{
          this.listaGenero = <Array<DValorDominio>>res;
          precargaProceso.close();
        },error=>{
          precargaProceso.close();
        }
    );    
  }    

    private consultarActividadesVigentes()
    { 
	////////////////Consulta el listado de actividades vigentes para el año
	let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    let anio = this.modelo.doc.cab.cs_id_1;
    if(this.modelo.doc.cuerpo.cs_id_27 && (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == 1)){
        anio = Number(anio) + 1;
    }
    this.dServicioRESTAPI.consultarActividadesVigentes(String(anio)).subscribe(res1 => {
        let actividadesEconomicas = <any>res1;
        this.listaActividadesEconomicasVigentes = actividadesEconomicas;
        this.obtenerActividadesEconomicas();
        precargaProceso.close();
    }, error =>{
        this.dNotificacionServicio.mostrarDialogoError("Error obteniendo parametros del contribuyente: Actividad Economica");
        precargaProceso.close();
    });           
  }

  private obtenerActividadesEconomicas(){
	  let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dRutServicios.consultarActividadesEconomicasContribuyente(this.modelo.doc.cab.cs_id_5).subscribe(res1 => {
		let actividadesEconomicas = <DActividadesEconomicas>res1;
        if (actividadesEconomicas != null && res1.hasOwnProperty('0') ){
            let actividadEconomica = this.listaActividadesEconomicasVigentes.find(act => actividadesEconomicas[0].id == act.codigo);
            if(actividadEconomica){
				
                if((!this.modelo.doc.cab.cs_id_4 || this.modelo.doc.cab.cs_id_4 =="")){
                  this.modelo.doc.cuerpo.cs_id_24 = actividadEconomica.codigo;   
                }
            }else{
				if((!this.modelo.doc.cuerpo.cs_id_24)){     
                  this.dNotificacionServicio.mostrarDialogoInformacion("Registre la actividad económica principal vigente a 31 de diciembre del año gravable que está presentando, según la Resolución 000139 de 2012");
              }
            }
			} else{
            if((!this.modelo.doc.cuerpo.cs_id_24)){
                this.dNotificacionServicio.mostrarDialogoInformacion("Registre la actividad económica principal vigente a 31 de diciembre del año gravable que está presentando, según la Resolución 000139 de 2012");
            }
      }          
        precargaProceso.close();
    }, error =>{
		this.dNotificacionServicio.mostrarDialogoError("Error obteniendo parametros del contribuyente: Actividad Economica");
        precargaProceso.close();
    });
  }
  

  //Metodos Declaración Sugerida

 


  //Metodos Factura Renta
  setDeclaracionSugerida(declaracionSugerida) {
    this.declaracionSugerida = declaracionSugerida;
  }

  setModelo(modelo) {
    this.modelo = modelo;
  }

  getDeclaracionSugerida() {
    return this.declaracionSugerida;
  }

  getModelo() {
    return this.modelo;
  }


  public DialogoValoresDeclaSugerida():void{ 
    let dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.data = this.modelo.doc.cab.cs_id_1;
    //dialogConfig.autoFocus = false;
    dialogConfig.data = this.declaracionSugerida;
    let dialogRef : any;
   

    

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        //Cargar variable de aceptación ---------------------------------------------------------------------------
        // this.declaracionSugerida.ideAceptacion = 'S'; 
        //Cargar valores en el borrador        
        this.modelo.doc.cuerpo.cs_id_29 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla29, true); 
        this.modelo.doc.cuerpo.cs_id_30 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla30, true); 
        this.modelo.doc.cuerpo.cs_id_32 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla32, true);
        this.modelo.doc.cuerpo.cs_id_33 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla33, true);
        this.modelo.doc.cuerpo.cs_id_35 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla35, true);
        this.modelo.doc.cuerpo.cs_id_36 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla36, true);
        this.modelo.doc.cuerpo.cs_id_39 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla39, true);
      //  this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla41, true);
        this.modelo.doc.cuerpo.cs_id_43 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla43, true);
        this.modelo.doc.cuerpo.cs_id_44 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla44, true);
        this.modelo.doc.cuerpo.cs_id_47 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla47, true);
        this.modelo.doc.cuerpo.cs_id_48 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla48, true);
        this.modelo.doc.cuerpo.cs_id_51 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla51, true);
       // this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla53, true);
        this.modelo.doc.cuerpo.cs_id_58 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla58, true);
        this.modelo.doc.cuerpo.cs_id_59 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla59, true);
        this.modelo.doc.cuerpo.cs_id_63 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla63, true); 
        this.modelo.doc.cuerpo.cs_id_64 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla64, true); 
        this.modelo.doc.cuerpo.cs_id_67 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla67, true); 
       // this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla69, true);
        this.modelo.doc.cuerpo.cs_id_74 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla74, true);
        this.modelo.doc.cuerpo.cs_id_76 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla76, true);
        this.modelo.doc.cuerpo.cs_id_80 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla80, true);
        this.modelo.doc.cuerpo.cs_id_81 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla81, true);
        this.modelo.doc.cuerpo.cs_id_84 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla84, true);
       // this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla86, true);
        this.modelo.doc.cuerpo.cs_id_98 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla98, true);
        this.modelo.doc.cuerpo.cs_id_99 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla99, true);
        this.modelo.doc.cuerpo.cs_id_100 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla100, true); 
        this.modelo.doc.cuerpo.cs_id_102 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla102, true); 
        this.modelo.doc.cuerpo.cs_id_104 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla104, true); 
        this.modelo.doc.cuerpo.cs_id_105 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla105, true); 
        this.modelo.doc.cuerpo.cs_id_107 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla107, true);
        this.modelo.doc.cuerpo.cs_id_108 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla108, true);
        this.modelo.doc.cuerpo.cs_id_110 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla110, true);
        this.modelo.doc.cuerpo.cs_id_111 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla111, true);
        this.modelo.doc.cuerpo.cs_id_123 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla123, true);
        this.modelo.doc.cuerpo.cs_id_124 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla124, true);
        this.modelo.doc.cuerpo.cs_id_125 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla125, true);
        this.modelo.doc.cuerpo.cs_id_131 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla131, true);
        this.modelo.doc.cuerpo.cs_id_132 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla132, true);
        this.modelo.doc.cuerpo.cs_id_133 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla133, true);
        this.modelo.doc.cuerpo.cs_id_134 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla134, true);
        //////////////////////////////////////////////////////////
        ////Agregado Factura Renta 18-08-2022
        this.modelo.doc.cuerpo.cs_id_38 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla38, true);
        this.modelo.doc.cuerpo.cs_id_45 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla45, true);
        this.modelo.doc.cuerpo.cs_id_50 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla50, true);
        this.modelo.doc.cuerpo.cs_id_56 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla56, true);
        this.modelo.doc.cuerpo.cs_id_60 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla60, true);
        this.modelo.doc.cuerpo.cs_id_62 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla62, true);
        this.modelo.doc.cuerpo.cs_id_66 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla66, true);
        this.modelo.doc.cuerpo.cs_id_72 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla72, true);
        this.modelo.doc.cuerpo.cs_id_75 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla75, true);
        this.modelo.doc.cuerpo.cs_id_77 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla77, true);
        this.modelo.doc.cuerpo.cs_id_79 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla79, true);
        this.modelo.doc.cuerpo.cs_id_83 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla83, true);
        this.modelo.doc.cuerpo.cs_id_89 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla89, true);
        this.modelo.doc.cuerpo.cs_id_94 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla94, true);
        this.modelo.doc.cuerpo.cs_id_95 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla95, true);
        this.modelo.doc.cuerpo.cs_id_96 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla96, true);
        this.modelo.doc.cuerpo.cs_id_109 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla109, true);
        this.modelo.doc.cuerpo.cs_id_112 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla112, true);
        this.modelo.doc.cuerpo.cs_id_113 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla113, true);
        this.modelo.doc.cuerpo.cs_id_114 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla114, true);
        this.modelo.doc.cuerpo.cs_id_115 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla115, true);
        this.modelo.doc.cuerpo.cs_id_121 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla121, true);
        this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla127, true);
        this.modelo.doc.cuerpo.cs_id_128 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla128, true);
        this.modelo.doc.cuerpo.cs_id_129 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla129, true);
        /////////////////////////////////////////////////////////
        //this.operacionCs32_33();
        this.operacionCs31();
        this.operacionCs34();
        this.operacionCs41();
       // this.operacionCs43_44_45();
       this.operacionCs46();
        this.operacionCs49();
        this.operacionCs270();
        this.operacionCs265();
        this.operacionCs37();
        this.operacionCs40();
        this.operacionCs52();
        this.operacionCs53();
        this.operacionCs54();
       // this.operacionCs58_59_60();
        this.operacionCs65();
        this.operacionCs68();
        this.operacionCs61();
        this.operacionCs82();
        this.operacionCs85();
        this.operacionCs78();
        this.operacionCs101();
        this.operacionCs106();
        this.operacionCs116();
        this.operacionCs121();
        
      }else{
        this.declaracionSugerida.ideAceptacion = 'N';
      }
    });
  }
  public calcularOperacionesSugerida(modelo:DDocumento,uvtFOR: string)
  {
    this.dProcesarInicializarDoc = new DProcesarInicializarDoc(this.modelo, this.dutilidades,null);
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1; 
    this.rangosArt241ETNumeral2 = DRangosArt241ET.NUMERAL_2;
    this.rangosArt241ETInciso1 = DRangosArt241ET.INCISO_1;
    this.tabla1 = DRangosArt241ET.TABLA1;
    this.tabla2 = DRangosArt241ET.TABLA2;
    this.esDecretoMocoa = false;
    this.UVT=uvtFOR;
    this.modelo=modelo;

    this.recalcularFormulario();
  /*  this.operacionCs31();
    
    this.operacionCs34();
    this.operacionCs41();
    this.operacionCs46();
    this.operacionCs49();
    this.operacionCs270();
    this.operacionCs265();
    this.operacionCs37();
    this.operacionCs40();
    this.operacionCs52();
    this.operacionCs53();
    this.operacionCs54();
    this.operacionCs65();
    this.operacionCs68();
    this.operacionCs61();
    this.operacionCs82();
    this.operacionCs85();
    this.operacionCs78();
    this.operacionCs101();
    this.operacionCs106();
    this.operacionCs111();
    this.operacionCs114();
    this.operacionCs116();
    this.operacionCs121();*/
    return this.modelo;
  }

    

  public validarDeclaSugeridaGuardar(){
    if(this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida();
      console.log("*************************************",this.declaracionSugerida)
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
      //this.guardarActualizarBorrador();
  }

  public validarDeclaSugeridaGuardarDefinitivo(){
    if(this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida(); 
      this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
      this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;          
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
   // this.guardarFormularioDefinitivo();
  }

  public validarDeclaSugeridaPresentar(){
    if(this.declaracionSugerida){
      this.asignarValoresRealesDeclaracionSugerida();
      this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
      this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    //this.presentarFormulario();    
  }

  public asignarValoresRealesDeclaracionSugerida(){
    //actualizar valores reales    
    this.declaracionSugerida.valRealCasilla29 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_29);
    this.declaracionSugerida.valRealCasilla30 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_30);
    this.declaracionSugerida.valRealCasilla32 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_32);
    this.declaracionSugerida.valRealCasilla33 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_33);
    this.declaracionSugerida.valRealCasilla35 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_35);
    this.declaracionSugerida.valRealCasilla36 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_36);
    this.declaracionSugerida.valRealCasilla39 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_39);
    //  this.declaracionSugerida.valRealCasilla41 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_41);
    this.declaracionSugerida.valRealCasilla43 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43);
    this.declaracionSugerida.valRealCasilla44 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_44);
    this.declaracionSugerida.valRealCasilla47 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_47);
    this.declaracionSugerida.valRealCasilla48 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_48);
    this.declaracionSugerida.valRealCasilla51 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_51);
    //  this.declaracionSugerida.valRealCasilla53 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_53);  
    this.declaracionSugerida.valRealCasilla58 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_58);
    this.declaracionSugerida.valRealCasilla59 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_59);
    this.declaracionSugerida.valRealCasilla63 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_63);
    this.declaracionSugerida.valRealCasilla64 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_64);
    this.declaracionSugerida.valRealCasilla67 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_67);
    //  this.declaracionSugerida.valRealCasilla69 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_69);
    this.declaracionSugerida.valRealCasilla74 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_74);
    this.declaracionSugerida.valRealCasilla76 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_76);
    this.declaracionSugerida.valRealCasilla80 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_80);
    this.declaracionSugerida.valRealCasilla81 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_81);
    this.declaracionSugerida.valRealCasilla84 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_84);
    // this.declaracionSugerida.valRealCasilla86 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_86);  
    this.declaracionSugerida.valRealCasilla98 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_98);
    this.declaracionSugerida.valRealCasilla99 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_99);
    this.declaracionSugerida.valRealCasilla100 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_100);
    this.declaracionSugerida.valRealCasilla102 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_102);
    this.declaracionSugerida.valRealCasilla104 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_104);
    this.declaracionSugerida.valRealCasilla105 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_105);
    this.declaracionSugerida.valRealCasilla107 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_107);
    this.declaracionSugerida.valRealCasilla108 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_108);
    this.declaracionSugerida.valRealCasilla110 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_110);
    this.declaracionSugerida.valRealCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valRealCasilla123 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_123);
    this.declaracionSugerida.valRealCasilla124 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_124);
    this.declaracionSugerida.valRealCasilla125 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_125);
    this.declaracionSugerida.valRealCasilla131 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_131);
    this.declaracionSugerida.valRealCasilla132 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_132);
    this.declaracionSugerida.valRealCasilla133 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_133);
    this.declaracionSugerida.valRealCasilla134 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_134);
    /////////////////////////////////////////////////////////////////////////
    ////////Agregado Factura Renta 18-08-2022
    ////////////////////////////////////////////////////////////////////////
    this.declaracionSugerida.valRealCasilla38 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_38);
    this.declaracionSugerida.valRealCasilla45 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_45);
    this.declaracionSugerida.valRealCasilla50 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_50);
    this.declaracionSugerida.valRealCasilla56 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_56);
    this.declaracionSugerida.valRealCasilla60 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_60);
    this.declaracionSugerida.valRealCasilla62 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_62);
    this.declaracionSugerida.valRealCasilla66 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_66);
    this.declaracionSugerida.valRealCasilla72 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_72);
    this.declaracionSugerida.valRealCasilla75 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_75);
    this.declaracionSugerida.valRealCasilla77 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_77);
    this.declaracionSugerida.valRealCasilla79 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_79);
    this.declaracionSugerida.valRealCasilla83 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_83);
    this.declaracionSugerida.valRealCasilla89 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_89);
    this.declaracionSugerida.valRealCasilla94 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_94);
    this.declaracionSugerida.valRealCasilla95 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_95);
    this.declaracionSugerida.valRealCasilla96 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_96);
    this.declaracionSugerida.valRealCasilla109 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_109);
    this.declaracionSugerida.valRealCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valRealCasilla113 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_113);
    this.declaracionSugerida.valRealCasilla114 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_114);
    this.declaracionSugerida.valRealCasilla115 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_115);
    this.declaracionSugerida.valRealCasilla121 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.declaracionSugerida.valRealCasilla127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.declaracionSugerida.valRealCasilla128 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_128);
    this.declaracionSugerida.valRealCasilla129 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_129);
    this.limpiaformatoSugeridos();
    //const booltipoDeclaracion = this.comparaSugerida();
    /*if (booltipoDeclaracion && this.declaracionSugerida.ideTipoRegistro == '60600003') {
      this.declaracionSugerida.ideTipoDeclaracion = 34031011;
      this.modelo.doc.cuerpo.cs_id_285 = 'true';
    } else {*/
    this.declaracionSugerida.ideTipoDeclaracion = 34022891;
    this.modelo.doc.cuerpo.cs_id_285 = 'false';
    //}

    if (!this.declaracionSugerida.ideAceptacion)
      this.declaracionSugerida.ideAceptacion = 'S';
    
  }

 /* private comparaSugerida()
  {
    if(this.declaracionSugerida.valSugeridoCasilla29!=null && this.declaracionSugerida.valRealCasilla29!=this.declaracionSugerida.valSugeridoCasilla29){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla30!=null && this.declaracionSugerida.valRealCasilla30!=this.declaracionSugerida.valSugeridoCasilla30){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla32!=null && this.declaracionSugerida.valRealCasilla32!=this.declaracionSugerida.valSugeridoCasilla32){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla33!=null && this.declaracionSugerida.valRealCasilla33!=this.declaracionSugerida.valSugeridoCasilla33){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla35!=null && this.declaracionSugerida.valRealCasilla35!=this.declaracionSugerida.valSugeridoCasilla35){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla36!=null && this.declaracionSugerida.valRealCasilla36!=this.declaracionSugerida.valSugeridoCasilla36){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla39!=null && this.declaracionSugerida.valRealCasilla39!=this.declaracionSugerida.valSugeridoCasilla39){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla43!=null && this.declaracionSugerida.valRealCasilla43!=this.declaracionSugerida.valSugeridoCasilla43){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla44!=null && this.declaracionSugerida.valRealCasilla44!=this.declaracionSugerida.valSugeridoCasilla44){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla47!=null && this.declaracionSugerida.valRealCasilla47!=this.declaracionSugerida.valSugeridoCasilla47){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla48!=null && this.declaracionSugerida.valRealCasilla48!=this.declaracionSugerida.valSugeridoCasilla48){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla51!=null && this.declaracionSugerida.valRealCasilla51!=this.declaracionSugerida.valSugeridoCasilla51){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla58!=null && this.declaracionSugerida.valRealCasilla58!=this.declaracionSugerida.valSugeridoCasilla58){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla59!=null && this.declaracionSugerida.valRealCasilla59!=this.declaracionSugerida.valSugeridoCasilla59){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla63!=null && this.declaracionSugerida.valRealCasilla63!=this.declaracionSugerida.valSugeridoCasilla63){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla64!=null && this.declaracionSugerida.valRealCasilla64!=this.declaracionSugerida.valSugeridoCasilla64){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla67!=null && this.declaracionSugerida.valRealCasilla67!=this.declaracionSugerida.valSugeridoCasilla67){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla74!=null && this.declaracionSugerida.valRealCasilla74!=this.declaracionSugerida.valSugeridoCasilla74){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla76!=null && this.declaracionSugerida.valRealCasilla76!=this.declaracionSugerida.valSugeridoCasilla76){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla80!=null && this.declaracionSugerida.valRealCasilla80!=this.declaracionSugerida.valSugeridoCasilla80){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla81!=null && this.declaracionSugerida.valRealCasilla81!=this.declaracionSugerida.valSugeridoCasilla81){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla84!=null && this.declaracionSugerida.valRealCasilla84!=this.declaracionSugerida.valSugeridoCasilla84){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla98!=null && this.declaracionSugerida.valRealCasilla98!=this.declaracionSugerida.valSugeridoCasilla98){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla99!=null && this.declaracionSugerida.valRealCasilla99!=this.declaracionSugerida.valSugeridoCasilla99){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla100!=null && this.declaracionSugerida.valRealCasilla100!=this.declaracionSugerida.valSugeridoCasilla100){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla102!=null && this.declaracionSugerida.valRealCasilla102!=this.declaracionSugerida.valSugeridoCasilla102){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla104!=null && this.declaracionSugerida.valRealCasilla104!=this.declaracionSugerida.valSugeridoCasilla104){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla105!=null && this.declaracionSugerida.valRealCasilla105!=this.declaracionSugerida.valSugeridoCasilla105){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla107!=null && this.declaracionSugerida.valRealCasilla107!=this.declaracionSugerida.valSugeridoCasilla107){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla108!=null && this.declaracionSugerida.valRealCasilla108!=this.declaracionSugerida.valSugeridoCasilla108){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla110!=null && this.declaracionSugerida.valRealCasilla110!=this.declaracionSugerida.valSugeridoCasilla110){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla111!=null && this.declaracionSugerida.valRealCasilla111!=this.declaracionSugerida.valSugeridoCasilla111){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla123!=null && this.declaracionSugerida.valRealCasilla123!=this.declaracionSugerida.valSugeridoCasilla123){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla124!=null && this.declaracionSugerida.valRealCasilla124!=this.declaracionSugerida.valSugeridoCasilla124){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla125!=null && this.declaracionSugerida.valRealCasilla125!=this.declaracionSugerida.valSugeridoCasilla125){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla131!=null && this.declaracionSugerida.valRealCasilla131!=this.declaracionSugerida.valSugeridoCasilla131){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla132!=null && this.declaracionSugerida.valRealCasilla132!=this.declaracionSugerida.valSugeridoCasilla132){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla133!=null && this.declaracionSugerida.valRealCasilla133!=this.declaracionSugerida.valSugeridoCasilla133){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla134!=null && this.declaracionSugerida.valRealCasilla134!=this.declaracionSugerida.valSugeridoCasilla134){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla38!=null && this.declaracionSugerida.valRealCasilla38!=this.declaracionSugerida.valSugeridoCasilla38){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla45!=null && this.declaracionSugerida.valRealCasilla45!=this.declaracionSugerida.valSugeridoCasilla45){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla50!=null && this.declaracionSugerida.valRealCasilla50!=this.declaracionSugerida.valSugeridoCasilla50){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla56!=null && this.declaracionSugerida.valRealCasilla56!=this.declaracionSugerida.valSugeridoCasilla56){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla60!=null && this.declaracionSugerida.valRealCasilla60!=this.declaracionSugerida.valSugeridoCasilla60){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla62!=null && this.declaracionSugerida.valRealCasilla62!=this.declaracionSugerida.valSugeridoCasilla62){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla66!=null && this.declaracionSugerida.valRealCasilla66!=this.declaracionSugerida.valSugeridoCasilla66){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla72!=null && this.declaracionSugerida.valRealCasilla72!=this.declaracionSugerida.valSugeridoCasilla72){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla75!=null && this.declaracionSugerida.valRealCasilla75!=this.declaracionSugerida.valSugeridoCasilla75){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla77!=null && this.declaracionSugerida.valRealCasilla77!=this.declaracionSugerida.valSugeridoCasilla77){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla79!=null && this.declaracionSugerida.valRealCasilla79!=this.declaracionSugerida.valSugeridoCasilla79){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla83!=null && this.declaracionSugerida.valRealCasilla83!=this.declaracionSugerida.valSugeridoCasilla83){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla89!=null && this.declaracionSugerida.valRealCasilla89!=this.declaracionSugerida.valSugeridoCasilla89){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla94!=null && this.declaracionSugerida.valRealCasilla94!=this.declaracionSugerida.valSugeridoCasilla94){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla95!=null && this.declaracionSugerida.valRealCasilla95!=this.declaracionSugerida.valSugeridoCasilla95){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla96!=null && this.declaracionSugerida.valRealCasilla96!=this.declaracionSugerida.valSugeridoCasilla96){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla109!=null && this.declaracionSugerida.valRealCasilla109!=this.declaracionSugerida.valSugeridoCasilla109){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla112!=null && this.declaracionSugerida.valRealCasilla112!=this.declaracionSugerida.valSugeridoCasilla112){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla113!=null && this.declaracionSugerida.valRealCasilla113!=this.declaracionSugerida.valSugeridoCasilla113){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla114!=null && this.declaracionSugerida.valRealCasilla114!=this.declaracionSugerida.valSugeridoCasilla114){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla115!=null && this.declaracionSugerida.valRealCasilla115!=this.declaracionSugerida.valSugeridoCasilla115){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla121!=null && this.declaracionSugerida.valRealCasilla121!=this.declaracionSugerida.valSugeridoCasilla121){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla127!=null && this.declaracionSugerida.valRealCasilla127!=this.declaracionSugerida.valSugeridoCasilla127){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla128!=null && this.declaracionSugerida.valRealCasilla128!=this.declaracionSugerida.valSugeridoCasilla128){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    if(this.declaracionSugerida.valSugeridoCasilla129!=null && this.declaracionSugerida.valRealCasilla129!=this.declaracionSugerida.valSugeridoCasilla129){ this.tipoDeclaracion = false; return this.tipoDeclaracion;}
    this.tipoDeclaracion = true; return this.tipoDeclaracion;
    

  }*/

  private limpiaformatoSugeridos() {
    //actualizar valores reales    
    this.declaracionSugerida.valSugeridoCasilla29 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_29);
    this.declaracionSugerida.valSugeridoCasilla30 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_30);
    this.declaracionSugerida.valSugeridoCasilla32 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_32);
    this.declaracionSugerida.valSugeridoCasilla33 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_33);
    this.declaracionSugerida.valSugeridoCasilla35 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_35);
    this.declaracionSugerida.valSugeridoCasilla36 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_36);
    this.declaracionSugerida.valSugeridoCasilla39 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_39);
    //  this.declaracionSugerida.valSugeridoCasilla41 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_41);
    this.declaracionSugerida.valSugeridoCasilla43 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43);
    this.declaracionSugerida.valSugeridoCasilla44 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_44);
    this.declaracionSugerida.valSugeridoCasilla47 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_47);
    this.declaracionSugerida.valSugeridoCasilla48 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_48);
    this.declaracionSugerida.valSugeridoCasilla51 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_51);
    //  this.declaracionSugerida.valSugeridoCasilla53 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_53);  
    this.declaracionSugerida.valSugeridoCasilla58 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_58);
    this.declaracionSugerida.valSugeridoCasilla59 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_59);
    this.declaracionSugerida.valSugeridoCasilla63 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_63);
    this.declaracionSugerida.valSugeridoCasilla64 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_64);
    this.declaracionSugerida.valSugeridoCasilla67 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_67);
    //  this.declaracionSugerida.valSugeridoCasilla69 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_69);
    this.declaracionSugerida.valSugeridoCasilla74 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_74);
    this.declaracionSugerida.valSugeridoCasilla76 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_76);
    this.declaracionSugerida.valSugeridoCasilla80 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_80);
    this.declaracionSugerida.valSugeridoCasilla81 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_81);
    this.declaracionSugerida.valSugeridoCasilla84 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_84);
    // this.declaracionSugerida.valSugeridoCasilla86 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_86);  
    this.declaracionSugerida.valSugeridoCasilla98 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_98);
    this.declaracionSugerida.valSugeridoCasilla99 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_99);
    this.declaracionSugerida.valSugeridoCasilla100 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_100);
    this.declaracionSugerida.valSugeridoCasilla102 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_102);
    this.declaracionSugerida.valSugeridoCasilla104 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_104);
    this.declaracionSugerida.valSugeridoCasilla105 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_105);
    this.declaracionSugerida.valSugeridoCasilla107 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_107);
    this.declaracionSugerida.valSugeridoCasilla108 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_108);
    this.declaracionSugerida.valSugeridoCasilla110 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_110);
    this.declaracionSugerida.valSugeridoCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valSugeridoCasilla123 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_123);
    this.declaracionSugerida.valSugeridoCasilla124 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_124);
    this.declaracionSugerida.valSugeridoCasilla125 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_125);
    this.declaracionSugerida.valSugeridoCasilla131 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_131);
    this.declaracionSugerida.valSugeridoCasilla132 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_132);
    this.declaracionSugerida.valSugeridoCasilla133 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_133);
    this.declaracionSugerida.valSugeridoCasilla134 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_134);
    /////////////////////////////////////////////////////////////////////////
    ////////Agregado Factura Renta 18-08-2022
    ////////////////////////////////////////////////////////////////////////
    this.declaracionSugerida.valSugeridoCasilla38 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_38);
    this.declaracionSugerida.valSugeridoCasilla45 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_45);
    this.declaracionSugerida.valSugeridoCasilla50 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_50);
    this.declaracionSugerida.valSugeridoCasilla56 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_56);
    this.declaracionSugerida.valSugeridoCasilla60 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_60);
    this.declaracionSugerida.valSugeridoCasilla62 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_62);
    this.declaracionSugerida.valSugeridoCasilla66 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_66);
    this.declaracionSugerida.valSugeridoCasilla72 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_72);
    this.declaracionSugerida.valSugeridoCasilla75 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_75);
    this.declaracionSugerida.valSugeridoCasilla77 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_77);
    this.declaracionSugerida.valSugeridoCasilla79 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_79);
    this.declaracionSugerida.valSugeridoCasilla83 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_83);
    this.declaracionSugerida.valSugeridoCasilla89 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_89);
    this.declaracionSugerida.valSugeridoCasilla94 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_94);
    this.declaracionSugerida.valSugeridoCasilla95 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_95);
    this.declaracionSugerida.valSugeridoCasilla96 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_96);
    this.declaracionSugerida.valSugeridoCasilla109 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_109);
    this.declaracionSugerida.valSugeridoCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valSugeridoCasilla113 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_113);
    this.declaracionSugerida.valSugeridoCasilla114 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_114);
    this.declaracionSugerida.valSugeridoCasilla115 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_115);
    this.declaracionSugerida.valSugeridoCasilla121 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.declaracionSugerida.valSugeridoCasilla127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.declaracionSugerida.valSugeridoCasilla128 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_128);
    this.declaracionSugerida.valSugeridoCasilla129 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_129);

   
  }
  private obtenerDeclaracionSugerida(){

    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    this.dServicioRESTAPI.obtenerDeclaracionSugerida(this.modelo.doc.cab.cs_id_5,this.anioDeclaracion).subscribe(
      res=>{
            this.listaDeclaracionSugerida = <any>res;
            let validaFactura=false;
            for (var i = 0; i < this.listaDeclaracionSugerida.length; i++) {
              if(this.listaDeclaracionSugerida[i].ideTipoRegistro =='60600003')  ////////////Factura Renta
                {
                  this.declaracionSugerida=this.listaDeclaracionSugerida[i];  
                  validaFactura=true;
                  break
                }
            }
            if(!validaFactura)
            {
              for (var i = 0; i < this.listaDeclaracionSugerida.length; i++) {
              if(this.listaDeclaracionSugerida[i].ideTipoRegistro =='60600002') /////Alerta Omiso
                {
                  this.declaracionSugerida=this.listaDeclaracionSugerida[i];  
                  validaFactura=true;
                  break
                }
            }
           }
           if(!validaFactura)
           {
             for (var i = 0; i < this.listaDeclaracionSugerida.length; i++) {
              if(this.listaDeclaracionSugerida[i].ideTipoRegistro =='60600001') /////Declaración Sugerida
               {
                 this.declaracionSugerida=this.listaDeclaracionSugerida[i];  
                 validaFactura=true;
                 break
               }
           }
          }  
          
            
          precargaProceso.close(); 
        }, error=>{          
          precargaProceso.close(); 
      }
    ); 
  }

  private actualizarDeclaracionSugerida(declaracionSugerida:any):void {
    delete declaracionSugerida['status'];
    delete declaracionSugerida['statusText'];
    console.log("modelo: ", this.modelo.doc.cab.cs_id_5);
    console.log("decla sugerida;", declaracionSugerida);
    this.dServicioRESTAPI.actualizarDeclaracionSugerida(this.modelo.doc.cab.cs_id_5, declaracionSugerida).subscribe(
      res=>{
      },error=>{
      }
    );
  }   


  private aplicarTablaArt241ET(baseGravable, rangos){
    let desde:boolean = false;
    let hasta:boolean = false;
    for(let i=0; i < rangos.length; i++){
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if((i+1)<rangos.length){
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i+1].desde);
      }else{
        hasta = true;
      }
      if(desde && hasta){
        let resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        let punto = resultadoMultiplicacion.indexOf(".");
        if(punto != -1){
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0,punto+3);
        }
        let resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        let resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;             
      }
    }

    return "0";
  }     

  private aplicarTablaCasilla121(baseGravable, rangos){
    let desde:boolean = false;
    let hasta:boolean = false;
    for(let i=0; i < rangos.length; i++){
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if((i+1)<rangos.length){
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i+1].desde);
      }else{
        hasta = true;
      }
      if(desde && hasta){
        let resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        let punto = resultadoMultiplicacion.indexOf(".");
        if(punto != -1){
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0,punto+3);
        }
        let resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        let resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;             
      }
    }

    return "0";
  }   

  private validarPregunta(idCasilla:number):void{
    let casillaPregunta = this.modelo.doc.cuerpo['cs_id_'+idCasilla];
    if(idCasilla != 299)
    {
      if(casillaPregunta == '0'){
        this.modelo.doc.cuerpo['cs_id_'+(idCasilla+1)] = '0';
        this.recalculoTemporales();
      }
    }
    else
    {
      if(casillaPregunta == '0'){
        this.modelo.doc.cuerpo['cs_id_297'] = '0';
        this.recalculoTemporales();
      }
    }
    
  }
  private recalculoTemporales(): void {
    this.operacionCs271();
    this.operacionCs265();
  }
  private calcularCasillasOcultas(): void {
    this.operacionCs270();
  }

  //Operaciones Casillas
  
 //Funciones de operaciones de casillas
 operacionCs31(): void {
  const cas29 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_29, true);
  const cas30 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_30, true);
  const resultadoResta31 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas29, cas30, true);
  const resultadoOperacion31 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta31, "0") ? "0" : resultadoResta31;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion31, true);
  this.modelo.doc.cuerpo.cs_id_31 = String(valorRedondeado);
}

operacionCs34(): void {
  const cas32 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_32, true);
  const cas33 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_33, true);
  const resultadoResta34 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas32, cas33, true);
  const resultadoOperacion34 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta34, "0") ? "0" : resultadoResta34;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion34, true);
  this.modelo.doc.cuerpo.cs_id_34 = String(valorRedondeado);
  this.operacionCs37();
}

operacionCs37(): void {
  const cas35 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_35, true);
  const cas36 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_36, true);
  const resultadoResta37 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas35, cas36, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta37, true);
  this.modelo.doc.cuerpo.cs_id_37 = String(valorRedondeado);
  this.operacionCs40();
}

operacionCs40(): void {
  const cas38 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_38, true);
  const cas39 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_39, true);
  const resultadoResta40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas38, cas39, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta40, true);
  this.modelo.doc.cuerpo.cs_id_40 = String(valorRedondeado);
  this.operacionCs41();
}

operacionCs41(): void {
  const cas37 = this.modelo.doc.cuerpo.cs_id_37;
  const cas40 = this.modelo.doc.cuerpo.cs_id_40;
  const cas34 = this.modelo.doc.cuerpo.cs_id_34;
  const cas273 = this.modelo.doc.cuerpo.cs_id_273;
  const resultadoSuma37y40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, resultadoSuma37y40, "0")) {
    this.modelo.doc.cuerpo.cs_id_41 = "0";
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoSuma37y40, cas34)) {
    this.modelo.doc.cuerpo.cs_id_41 = resultadoSuma37y40;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma37y40, cas34)) {
    this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoSuma37y40, cas34)) {
    this.modelo.doc.cuerpo.cs_id_41 = cas273;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma37y40, cas34)) {
    this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
  }

  this.operacionCs42();
  this.operacionCs265();
  this.operacionCs273();
}

operacionCs42(): void {
  const cas34 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_34, true);
  const cas41 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_41, true);
  const resultadoResta42 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas34, cas41, true);
  const resultadoOperacion42 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta42, "0") ? "0" : resultadoResta42;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion42, true);
  this.modelo.doc.cuerpo.cs_id_42 = String(valorRedondeado);
  this.operacionCs91();
}

operacionCs46(): void {
  const camposResta = ['cs_id_44', 'cs_id_45'];
  const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas43, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_46 = valorRedondeado;
  //this.operacionCs53();
  this.operacionCs49();
}

operacionCs49(): void {
  const cas47 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_47, true);
  const cas48 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_48, true);
  const resultadoResta49 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas47, cas48, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta49, true);
  this.modelo.doc.cuerpo.cs_id_49 = String(valorRedondeado);
 // this.operacionCs53();
 this.operacionCs52();
}

operacionCs52(): void {
  const cas50 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_50, true);
  const cas51 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_51, true);
  const resultadoResta52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas50, cas51, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta52, true);
  this.modelo.doc.cuerpo.cs_id_52 = String(valorRedondeado);
  this.operacionCs53();
  this.operacionCs266();
}

operacionCs53(): void {
  const cas49 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_49);
  const cas52 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_52);
  const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);
  const cas46 = this.modelo.doc.cuerpo.cs_id_46;
  const cas265 = this.modelo.doc.cuerpo.cs_id_265;

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma49_52, "0")) {
    this.modelo.doc.cuerpo.cs_id_53 = "0";
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
    this.modelo.doc.cuerpo.cs_id_53 = suma49_52;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
    this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
    this.modelo.doc.cuerpo.cs_id_53 = cas265;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
    this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
  }

  this.operacionCs54();
  this.operacionCs265();
}

operacionCs54(): void {
  const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
  const camposResta = ['cs_id_44', 'cs_id_45', 'cs_id_53'];
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas43, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_54 = valorRedondeado;
  this.operacionCs55();
}

operacionCs55(): void {
  const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
  const camposSuma = ['cs_id_44', 'cs_id_45'];
  const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, cas43, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_55 = valorRedondeado;
  this.operacionCs57();
}

operacionCs57(): void {
  const cas54 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_54, true);
  const cas56 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_56, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas54, cas56, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_57 = valorRedondeado;
  this.operacionCs91();
}

operacionCs61(): void {
  const camposResta = ['cs_id_59', 'cs_id_60'];
  const cas58 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_58, true);
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas58, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_61 = valorRedondeado;

  
  ///Se agrega por sugerida 2025
  const cas66 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_66, true);
  const cas67 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_67, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas66, cas67, true);
  const valorRedondeado1 = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_68 = valorRedondeado1;

  this.operacionCs69();
}

operacionCs65(): void {
  const cas63 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_63, true);
  const cas64 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_64, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas63, cas64, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_65 = valorRedondeado;
  this.operacionCs69();
}

operacionCs68(): void {
  const cas66 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_66, true);
  const cas67 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_67, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas66, cas67, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_68 = valorRedondeado;
  this.operacionCs69();
  this.operacionCs55();
}

operacionCs69(): void {
  const cas65 = this.modelo.doc.cuerpo.cs_id_65;
  const cas68 = this.modelo.doc.cuerpo.cs_id_68;
  const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true);
  const cas61 = this.modelo.doc.cuerpo.cs_id_61;
  const cas62 = this.modelo.doc.cuerpo.cs_id_62;
  const suma61_62 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas61, cas62, true);
  const cas266 = this.modelo.doc.cuerpo.cs_id_266;

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma65_68, "0")) {
    this.modelo.doc.cuerpo.cs_id_69 = "0";
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
    this.modelo.doc.cuerpo.cs_id_69 = suma65_68;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
    this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
    this.modelo.doc.cuerpo.cs_id_69 = cas266;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
    this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
  }
  this.operacionCs70();
  this.operacionCs265();
}

operacionCs70(): void {
  const camposSuma = ['cs_id_58', 'cs_id_62'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const camposResta = ['cs_id_59', 'cs_id_60', 'cs_id_69'];
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_70 = valorRedondeado;
  this.operacionCs71();
}

operacionCs71(): void {
  const camposSuma = ['cs_id_59', 'cs_id_60'];
  const camposResta = ['cs_id_58', 'cs_id_62'];
  const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_71 = valorRedondeado;
  this.operacionCs72();
  this.operacionCs73();
}

operacionCs72(): void {
  const cas70 = this.modelo.doc.cuerpo.cs_id_70;
  const cas72 = this.modelo.doc.cuerpo.cs_id_72;
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas72, cas70) ? cas70 : cas72 ;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_72 = valorRedondeado;
}

operacionCs73(): void {
  const cas70 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_70, true);
  const cas72 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_72, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas70, cas72, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_73 = valorRedondeado;
  this.operacionCs91();
}

operacionCs78(): void {
  const camposResta = ['cs_id_75', 'cs_id_76', 'cs_id_77'];
  const cas74 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_74, true);
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas74, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_78 = valorRedondeado;

  //Se agrega sugerida 2025
  const cas83 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_83, true);
  const cas84 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_84, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas83, cas84, true);
  const valorRedondeado1 = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_85 = valorRedondeado1;
  this.operacionCs86();
}

operacionCs79(): void {
  this.operacionCs270();
  this.operacionCs86();
}

operacionCs82(): void {
  const cas80 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_80, true);
  const cas81 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_81, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas80, cas81, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_82 = valorRedondeado;
  this.operacionCs86();
}

operacionCs85(): void {
  const cas83 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_83, true);
  const cas84 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_84, true);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas83, cas84, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_85 = valorRedondeado;
  this.operacionCs86();
}

operacionCs86(): void {
  const cas82 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_82);
  const cas85 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_85);
  const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true);
  const cas78 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_78);
  const cas79 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_79);
  const suma78_79 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas78, cas79, true);
  const cas267 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_267);

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma82_85, "0")) {
    this.modelo.doc.cuerpo.cs_id_86 = "0";
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
    this.modelo.doc.cuerpo.cs_id_86 = suma82_85;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
    this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
    this.modelo.doc.cuerpo.cs_id_86 = cas267;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
    this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
  }

  this.operacionCs87();
  this.operacionCs265();
}

operacionCs87(): void {
  const camposSuma = ['cs_id_74', 'cs_id_79'];
  const camposResta = ['cs_id_75', 'cs_id_76', 'cs_id_77', 'cs_id_86'];
  const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_87 = valorRedondeado;
  this.operacionCs88();
}

operacionCs88(): void {
  const camposSuma = ['cs_id_75', 'cs_id_76', 'cs_id_77'];
  const camposResta = ['cs_id_74', 'cs_id_79'];
  const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_88 = valorRedondeado;
  this.operacionCs89();
//   this.operacionCs90();
}

operacionCs89(): void {
  const cas87 = this.modelo.doc.cuerpo.cs_id_87;
  const cas89 = this.modelo.doc.cuerpo.cs_id_89;
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas89, cas87) ? cas87 : cas89 ;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_89 = valorRedondeado;
  this.operacionCs90();
}

operacionCs90(): void {
  const cas87 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_87, true);
  const cas89 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_89, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas87, cas89, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_90 = valorRedondeado;
  this.operacionCs91();
}

operacionCs91(): void {
  const camposSuma = ['cs_id_41', 'cs_id_42', 'cs_id_53', 'cs_id_57', 'cs_id_69', 'cs_id_73', 'cs_id_86', 'cs_id_90'];
  const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma, true);
  this.modelo.doc.cuerpo.cs_id_91 = valorRedondeado;
  this.operacionCs92();
}

operacionCs92(): void {
  this.operacionCs316();
  this.operacionCs139();
  let valorRedondeado = '0';
  const porcentaje297 = '0.01';
  const valoruvt240 = '240';
  let valorcasillaOperacion297 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelo.doc.cuerpo.cs_id_297, porcentaje297);
  let valorcasillaOperacion297p = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelo.doc.cuerpo.cs_id_297, porcentaje297);
  const UVT240 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt240, this.UVT);
  const mayorque = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorcasillaOperacion297, UVT240);

  if (mayorque) valorcasillaOperacion297 = UVT240;
  let valoredondeado28 = this.dutilidades.redondearValorMoneda(valorcasillaOperacion297p, true);
  
  
  const mayorque1 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valoredondeado28, UVT240);
  if (mayorque1) valoredondeado28 = UVT240;
  this.modelo.doc.cuerpo.cs_id_28 = valoredondeado28;
  const camposSuma = ['cs_id_41', 'cs_id_53', 'cs_id_69', 'cs_id_86','cs_id_28','cs_id_139'];
  let resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma, true);
  
  const cas91 =this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_91, true);
  const mayorque2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorRedondeado, cas91);
  if (mayorque2) this.modelo.doc.cuerpo.cs_id_92 = cas91;
  else this.modelo.doc.cuerpo.cs_id_92 = valorRedondeado;
  this.operacionCs93();
}

operacionCs93(): void {
  const cas91 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_91, true);
  const cas92 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_92, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas91, cas92, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_93 = valorRedondeado;
  this.operacionCs97();
}

operacionCs94(): void {
  const cas93 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_93, true);
  const cas94 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_94, true);
  const cas42 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_42, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas93, cas42, true);
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas94, resultadoResta)) {
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 94 no puede superar el valor de la casilla 93 menos la casilla 42");
    this.modelo.doc.cuerpo.cs_id_94 = "0";
  }
  this.operacionCs97();
}

operacionCs95(): void {
  const cas93 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_93, true);
  const cas94 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_94, true);
  const cas95 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_95, true);
  const resta93_94 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas93, cas94, true);
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resta93_94, cas95)) {
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 95 no puede superar el valor de la casilla 93 menos la casilla 94");
    this.modelo.doc.cuerpo.cs_id_95 = "0";
  }
  this.operacionCs97();
}

/*operacionCs97(): void {
    const camposSumaPrin = ['cs_id_93', 'cs_id_94', 'cs_id_96'];
    const cas95 = this.modelo.doc.cuerpo.cs_id_95;
    const resultadoCamposSumaprin = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaPrin, true);
    const resultadoCamposResta1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaprin, cas95, true);
    let resultadocas97 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoCamposResta1, '0', true);
    const camposSumaDivi = ['cs_id_106', 'cs_id_107', 'cs_id_305', 'cs_id_308', 'cs_id_311', 'cs_id_314', 'cs_id_318', 'cs_id_321', 'cs_id_324', 'cs_id_327', 'cs_id_330', 'cs_id_333'];
    const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
    resultadocas97 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadocas97, resultadoCamposSumaDiv, true);
    const camposSumaRDivi = ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
    const resultadoCamposSumaRDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaRDivi, true);
    resultadocas97 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadocas97, resultadoCamposSumaRDiv, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadocas97, true);
    this.modelo.doc.cuerpo.cs_id_97 = valorRedondeado;
    this.operacionCs101();

}*/

operacionCs97(): void {
  const camposSumaPrin = ['cs_id_93', 'cs_id_96'];
  const cas94 = this.modelo.doc.cuerpo.cs_id_94;
  const cas95 = this.modelo.doc.cuerpo.cs_id_95;
  const resultadoCamposSumaprin = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaPrin, true);
  const resultadoCamposResta1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaprin, cas94, true);
  const resultadoCamposResta2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposResta1, cas95, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta2, "0") ? "0" : resultadoCamposResta2;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_97 = valorRedondeado;
  this.operacionCs101();

}

operacionCs101(): void {
  const cas99 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_99, true);
  const cas100 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_100, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas99, cas100, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_101 = valorRedondeado;
  this.operacionCs103();
}

operacionCs102(): void {
  const cas102 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_102, true);
  const cas101 =  this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_101, true);
  /** 
  const val12Mil = "12000"
  const limite12MilUVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.UVT, val12Mil, true);
  */
  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas102, cas101) ){
    this.dNotificacionServicio.mostrarDialogoInformacion("Señor contribuyente recuerde que el Limite de las rentas exentas por ingresos de pension por año no debe superar la renta líquida. El valor ingresado en esta casilla será ajustado al tope máximo permitido.");
    this.modelo.doc.cuerpo.cs_id_102 = this.modelo.doc.cuerpo.cs_id_101;
  }
  /** 
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas102, limite12MilUVT) && ) {
    this.dNotificacionServicio.mostrarDialogoInformacion("Señor contribuyente recuerde que el Limite de las rentas exentas por ingresos de pension por año son 12000 UVT, el valor registrado excede este monto.");

  }
  */
  this.operacionCs103();
}

operacionCs103(): void {
  const cas101 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_101, true);
  const cas102 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_102, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas101, cas102, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_103 = valorRedondeado;
  this.operacionCs108();
//  this.operacionCs111();
}

operacionCs106(): void {
  const cas104 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_104, true);
  const cas105 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_105, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas104, cas105, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_106 = valorRedondeado;
  this.operacionCs118();
}

operacionCs108(): void {
    const camposSumaDivi = ['cs_id_305', 'cs_id_308', 'cs_id_311', 'cs_id_314', 'cs_id_318', 'cs_id_321', 'cs_id_324', 'cs_id_327', 'cs_id_330', 'cs_id_333'];
    const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
    const camposSumaImpuestos= ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
    const resultadoCamposSumaImp = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaImpuestos, true);
    //const valorRedondeadoImp = this.dutilidades.redondearValorMoneda(resultadoCamposSumaImp);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSumaDiv);
   // const resta111 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorRedondeado, valorRedondeadoImp, true);
   // this.modelo.doc.cuerpo.cs_id_111 = resta111;
    this.modelo.doc.cuerpo.cs_id_108 = valorRedondeado;
    this.operacionCs118();
   // this.operacionCs120();
    this.operacionCs111();
 
}
operacionCs111(): void {
  const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
  const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
  const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);
  const cas107 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_107);
  const cas298 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_298);
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas97, cas98)) {
    const camposSuma= ['cs_id_97','cs_id_103','cs_id_107','cs_id_298'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
    this.modelo.doc.cuerpo.cs_id_111 = resultado;
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas98, cas97))  
  {
    const camposSuma= ['cs_id_98','cs_id_103','cs_id_107','cs_id_298'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
    this.modelo.doc.cuerpo.cs_id_111 = resultado;
  } else {
    const camposSuma= ['cs_id_97','cs_id_103','cs_id_107','cs_id_298'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
    this.modelo.doc.cuerpo.cs_id_111 = resultado;
  }
  this.operacionCs114();
  this.operacionCs116();
}


/* operacionCs113(): void {
  const cas28 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_28, true);
  const cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112, true);
  const cas113 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_113, true);
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas113, cas28)) {
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 113 no puede superar el valor de la casilla 28");
    this.modelo.doc.cuerpo.cs_id_113 = "0";
  }
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas113, cas112)) {
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 113 no puede superar el valor de la casilla 112");
    this.modelo.doc.cuerpo.cs_id_113 = "0";
  }
  this.operacionCs116();
}
*/
operacionCs114(): void {
  let cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112,true);
  let cas113 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_113,true);
  let cas114 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_114,true);
  let cas274 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_274,true);
  let resta112_114 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, cas113, true);

  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas274, "0")){
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas114, "0")){
        this.dNotificacionServicio.mostrarDialogoError("Recuerde que  si en el periodo determinó pérdidas por ganancias ocasionales NO es procedente incluir en esta casilla ganancias ocasionales no gravadas y exentas, en caso de no tener pérdidas el valor incluido debe ser menor al valor de restar los costos al valor de  los ingresos");
        this.modelo.doc.cuerpo.cs_id_114 = "0"; 
      }
    }else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas274, "0") && (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas114, resta112_114))){
      this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 114 no puede superar el valor de la casilla 112 menos la casilla 113");
      this.modelo.doc.cuerpo.cs_id_114 = "0";
    }
  this.operacionCs115();
}

operacionCs115(): void {
  const cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112);
  const camposSuma= ['cs_id_113','cs_id_114'];
  const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoCamposResta =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, resultadoCamposSuma, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta, "0")?"0":resultadoCamposResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_115 = valorRedondeado;
  this.operacionCs127();
}

operacionCs116(): void {

  const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
  const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
  const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas97, cas98)) {
    const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
    const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_116 = resultado;
 } else if ((this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas97, "0")) && 
  (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas98, "0"))) {
    const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
    const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_116 = resultado;
  }
 else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas97, cas98)) {
  const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
  const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
  let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
  resultado = this.dutilidades.redondearValorMoneda(resultado, true);
  this.modelo.doc.cuerpo.cs_id_116 = resultado;
}
  else {
    this.modelo.doc.cuerpo.cs_id_116 = "0";
  }
  this.operacionCs117();
}

operacionCs117(): void {
  const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
  const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
  const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas98, cas97)) {
    let resultadoCamposSumasec = "0";
    
   /*   const camposSumaRDivi = ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
      const resultadoCamposSumaRDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaRDivi, true);
      const camposSumaDivi = ['cs_id_106', 'cs_id_107', 'cs_id_305', 'cs_id_308', 'cs_id_311', 'cs_id_314', 'cs_id_318', 'cs_id_321', 'cs_id_324', 'cs_id_327', 'cs_id_330', 'cs_id_333'];
      let resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
      resultadoCamposSumaDiv = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaDiv, resultadoCamposSumaRDiv, true);
      resultadoCamposSumasec = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoCamposSumasec, resultadoCamposSumaDiv, true);
    
    let resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas98, cas103, true);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, resultadoCamposSumasec, true);*/
    const cas111= this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111);
    const valorEnUvt = this.convertirPesosUvt(cas111);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_117 = resultado;
  } else {
    this.modelo.doc.cuerpo.cs_id_117 = "0";
  }
  this.operacionCs121();
}

operacionCs118(): void {
  const camposSumaRDivi = ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
  const resultadoCamposSumaRDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaRDivi, true);
  let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSumaRDiv, true);
  this.modelo.doc.cuerpo.cs_id_118 = resultado; 
  this.operacionCs119(true);
 // this.operacionCs120();
  //this.operacionCs121();
}

operacionCs119(booCalcula:Boolean): void {

  let cas106 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_106);
  let valorEnUvt = this.convertirPesosUvt(cas106);
  let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ETNumeral2);
  resultado = this.dutilidades.redondearValorMoneda(resultado, true);
  this.modelo.doc.cuerpo.cs_id_119 = resultado;
  this.operacionCs120();
  if(!booCalcula)
  {
    this.operacionCs111();
  }

}

operacionCs120(): void {
   
    const cas109 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_109);
    const cas110 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_110);
    const suma109_110 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas109, cas110, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma109_110, "0") ? "0" : suma109_110;
    const valC = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoOperacion, this.tarifaA);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(valC, true);
    this.modelo.doc.cuerpo.cs_id_120 = valorRedondeado;
    
  
    this.operacionCs121();
    this.operacionCs296();
   // this.operacionCs97();
}

operacionCs121(): void {
  const camposSuma = ['cs_id_116','cs_id_117','cs_id_118','cs_id_119', 'cs_id_120'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_121 = valorRedondeado;

  this.operacionCs123();
}

operacionCs122(): void {
  const cas122 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_122);
  const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas122, cas121)) {
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 122 no puede superar el valor de la casilla 121");
    this.modelo.doc.cuerpo.cs_id_122 = "0";
  }
  this.operacionCs124();
}

operacionCs123(): void {
  const cas116 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_116);
  const cas117 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_117);
  const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
  const cas123 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_123);
  const Cas121x30porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.30');
  const Cas121x25porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.25');
  this.modelo.doc.cuerpo.cs_id_123 = cas123;

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas116, cas117) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas123, Cas121x30porCien)) {
    this.modelo.doc.cuerpo.cs_id_123 = Cas121x30porCien;
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 123 no puede superar 30% del valor de la casilla 121");
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas117, cas116) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas123, Cas121x25porCien)) {
    this.modelo.doc.cuerpo.cs_id_123 = Cas121x25porCien;
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 123 no puede superar 25% del valor de la casilla 121");
  } else {
    this.operacionCs125();
  }
}

operacionCs124(): void {
    const cas124=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_124);
    const cas296=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_296);
   
    if(cas124=='0')
    {
      this.modelo.doc.cuerpo.cs_id_124 = cas296;
    }
    else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas296, cas124))
    {
     // this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 124 no puede ser inferior al valor de la casilla 296");
      this.modelo.doc.cuerpo.cs_id_124 = cas296;
    }
    this.operacionCs125();
}

operacionCs125(): void {
  const cas116 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_116);
  const cas117 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_117);
  const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
  const camposSuma = ['cs_id_122', 'cs_id_123', 'cs_id_124'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125);
  const Cas121x25porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.25');
  this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas116, cas117) &&
    this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas125, cas121)) {
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma, cas121)) {
      this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 125 no puede superar el valor de la casilla 121");
      let valorRedondeado = this.dutilidades.redondearValorMoneda(cas121, true);
      this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;
    }
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas117, cas116) &&
    this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas125, Cas121x25porCien)) {
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 125 no puede superar 25% del valor de la casilla 121");
    let valorRedondeado = this.dutilidades.redondearValorMoneda(Cas121x25porCien, true);
    this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;
  }
  this.operacionCs126();
}

operacionCs126(): void {
  const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121, true);
  const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125, true);
  const cas126 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_126, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas121, cas125, true);
  let resultadoOperacion='0';
  if(this.boolfinal)
  {
    const resultadoValidacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, cas126) ? cas126 : resultadoResta;
    resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoValidacion, "0") ? "0" : resultadoValidacion;
  }
  else
  {
    resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  }
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_126 = valorRedondeado;
  this.operacionCs127();
  this.operacionCs129();
}


operacionCs127(): void {
  const cas115 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_115);
  const cas115VeintePorciento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, '0.2');

 // const cas114 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_114);
  const cas115QuincePorciento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, '0.15');

  const cas127 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_127);

  let resultadoOperacion=cas127;

  if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas127,cas115QuincePorciento)) 
  {
    resultadoOperacion=this.dutilidades.redondearValorMoneda(cas115VeintePorciento);
  }
  else
   if ( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE,  cas127, cas115VeintePorciento))
   {
    resultadoOperacion=this.dutilidades.redondearValorMoneda(cas115VeintePorciento);
   }
  
  this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.redondearValorMoneda(resultadoOperacion);
  this.operacionCs129();
}

operacionCs129(): void {
  const camposSuma = ['cs_id_126', 'cs_id_127'];
  const cas128 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_128);
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, cas128, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_129 = valorRedondeado;
  this.operacionCs133();
}
 //Anticipo renta para el aÃ±o gravable siguiente - LiquidaciÃ³n privada
 operacionCs133() {

  let valor = "";

  const cas127 = this.modelo.doc.cuerpo.cs_id_127;
  const cas133 = this.modelo.doc.cuerpo.cs_id_133;
  const cas342 = this.modelo.doc.cuerpo.cs_id_342;
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas342, "1")) {
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas127, "0.25");
    valor = this.dutilidades.redondearValorMoneda(valor, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
      this.modelo.doc.cuerpo.cs_id_134 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
    } else {
      this.modelo.doc.cuerpo.cs_id_134 = "0";
    }
  } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas342, "2")) {

    //Calculo anticipo 50% - impuesto actual
  let cas389="0";
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas127, "0.5");
    valor = this.dutilidades.redondearValorMoneda(valor, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
      cas389 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
    }

    //Calculo anticipo 50% - impuesto promedio
  let cas390="0";
    let cas343 = this.modelo.doc.cuerpo.cs_id_343;
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas343, cas127);
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, "0.25");
    valor = this.dutilidades.redondearValorMoneda(valor, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
      cas390 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
    }

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas389, cas390)) {
      this.modelo.doc.cuerpo.cs_id_134 = cas389;
    } else {
      this.modelo.doc.cuerpo.cs_id_134 = cas390;
    }

  } else {

    //Calculo anticipo 75% - impuesto actual
  let cas391="0";
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas127, "0.75");
    valor = this.dutilidades.redondearValorMoneda(valor, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
      cas391 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
    }

    //Calculo anticipo 75% - impuesto promedio
    let cas343 = this.modelo.doc.cuerpo.cs_id_343;
    let cas392 = "0";
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas343, cas127);
    valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valor, "0.375");
    valor = this.dutilidades.redondearValorMoneda(valor, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valor, cas133)) {
      cas392 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valor, cas133);
    }

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas391, cas392)) {
      this.modelo.doc.cuerpo.cs_id_134 = cas391;
    } else {
      this.modelo.doc.cuerpo.cs_id_134 = cas392;
    }
  }

  this.operacionCs134();
}

operacionCs134(): void {
  const camposSuma = ['cs_id_129', 'cs_id_133'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const camposResta = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
  const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_134 = valorRedondeado;
  this.operacionCs136();
}

operacionCs136(): void {
  const camposSuma = ['cs_id_129', 'cs_id_133', 'cs_id_135'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const camposResta = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
  const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_136 = valorRedondeado;
  this.operacionCs137();
}

operacionCs137(): void {
  const camposSuma = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const camposResta = ['cs_id_129', 'cs_id_133', 'cs_id_135'];
  const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_137 = valorRedondeado;
}

private operacionCs287 () : void{
  if( this.modelo.doc.cuerpo.cs_id_241 != null && this.modelo.doc.cuerpo.cs_id_242 != null  && this.modelo.doc.cuerpo.cs_id_244 != null &&
    this.modelo.doc.cuerpo.cs_id_241 != "" && this.modelo.doc.cuerpo.cs_id_242 != ""  && this.modelo.doc.cuerpo.cs_id_244 != "" )
    {
      this.habilitaDependiente2 = false;
      if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 )
     {  
        this.habilitaDependiente5 = false;
       
     }
      this.contarDependientes();
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    }
  else
  {
    this.habilitaDependiente2 = true;
  }
  this.operacionCs92();
}
operacionCs242(): void {
  this.modelo.doc.cuerpo.cs_id_335 = '0'; 
  const cas355=Number(this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_355));
  if(cas355>0 )
  {
    this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"¿Desea aplicar un dependiente económico como deducción?").afterClosed().subscribe(result => {
      if (result) this.modelo.doc.cuerpo.cs_id_335 = '1';
      this.operacionCs92();
    });
  }
  
}

operacionCs265(): void {
  const cas273 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_273, true);
  const cas41 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_41, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas273, cas41, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_265 = valorRedondeado;

  const cas46 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_46);
  const cas49 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_49);
  const cas52 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_52);
  const cas265 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_265);
  const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, "0")) {
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
      this.temporal53 = suma49_52;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
      this.temporal53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
      this.temporal53 = cas265;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
      this.temporal53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;;
    }
  }
  this.operacionCs266();
}

operacionCs266(): void {
  const cas265 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_265, true);
  const cas53 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_53, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas265, cas53, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_266 = valorRedondeado;

  const cas61 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_61); //RENTA LIQUIDA
  const cas62 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_62); //RENTA LIQUIDA
  const cas65 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_65); //RENTAS EXCENTAS	
  const cas68 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_68); //DEDUCIONES IMPUTABLES
  const cas266 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_266);
  const suma61_62 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas61, cas62, true); //RENTAS LIQUIDAS PASIVAS
  const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true); //RENTAS EXCENTAS

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, "0")) {
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
      this.temporal69 = suma65_68;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
      this.temporal69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
      this.temporal69 = cas266;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
      this.temporal69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
    }
  }
  this.operacionCs267();
}

operacionCs267(): void {
  const cas266 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_266, true);
  const cas69 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_69, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas266, cas69, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_267 = valorRedondeado;

  const cas78 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_78); //RENTA LIQUIDA
  const cas79 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_79); //RENTA LIQUIDA
  const cas82 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_82); //RENTAS EXCENTAS	
  const cas85 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_85); //DEDUCIONES IMPUTABLES
  const cas267 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_267);
  const suma78_79 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas78, cas79, true); //RENTAS LIQUIDAS PASIVAS
  const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true); //RENTAS EXCENTAS

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, "0")) {
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
      this.temporal86 = suma82_85;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
      this.temporal86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) ? suma78_79 : cas267;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma78_79, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
      this.temporal86 = cas267;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
      this.temporal86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
    }
  }
}

operacionCs270(): void {
  const camposSuma = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74'];
  const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const camposResta = ['cs_id_33', 'cs_id_44', 'cs_id_59', 'cs_id_76'];
  const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_270 = valorRedondeado;
  this.operacionCs271();
}

operacionCs271(): void {
  ////modificado 09-04-2024 tutela
  
  const camposPrimeraSuma = ['cs_id_270', 'cs_id_62', 'cs_id_79'];
  const resultadoPrimeraSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposPrimeraSuma, true);
  const primerFactorx40porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoPrimeraSuma, '0.40');
  
  const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
  const segundoFactor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  
  const resultadoSumaFactores = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, primerFactorx40porCien, segundoFactor, true);
  
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSumaFactores, "0") ? "0" : resultadoSumaFactores;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_271 = valorRedondeado;
  
  
  /*const camposPrimeraSuma = ['cs_id_270', 'cs_id_62', 'cs_id_79'];
  const resultadoPrimeraSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposPrimeraSuma, true);
  const camposResta = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
  const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
  const primerFactor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoPrimeraSuma, resultadoResta, true);
  const primerFactorx40porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, primerFactor, '0.40');
  const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
  const segundoFactor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  const resultadoSumaFactores = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, primerFactorx40porCien, segundoFactor, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSumaFactores, "0") ? "0" : resultadoSumaFactores;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  this.modelo.doc.cuerpo.cs_id_271 = valorRedondeado;
  */
  
  this.operacionCs272();
}

operacionCs272(): void {
  let uvtDefecto = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.UVT, '1340');
  const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
  let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
  resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, uvtDefecto);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_272 = valorRedondeado;
  this.operacionCs273();
}

operacionCs273(): void {

  const cas270 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_270, true);
  const cas271 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_271, true);
  const cas272 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_272, true);

  const cas270Menorq271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas270, cas271);
  const cas270Menorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas270, cas272);
  const cas270Mayorq271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas270, cas271);
  const cas270Mayorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas270, cas272);
  const cas270Iguala271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, cas271);
  const cas270Iguala272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, cas272);
  const cas271Menorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas271, cas272);
  const cas271Mayorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas271, cas272);
  const cas270Menoigual272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas270, cas272);

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, "0"))
    this.modelo.doc.cuerpo.cs_id_273 = "0";
  else if (cas270Menorq271 && cas270Menorq272)
    this.modelo.doc.cuerpo.cs_id_273 = cas270;
  else if (cas270Mayorq271 && cas270Menoigual272)
    this.modelo.doc.cuerpo.cs_id_273 = cas271;
  else if (cas270Mayorq271 && cas270Mayorq272 && cas271Menorq272)
    this.modelo.doc.cuerpo.cs_id_273 = cas271;
  else if (cas270Mayorq271 && cas270Mayorq272 && cas271Mayorq272)
    this.modelo.doc.cuerpo.cs_id_273 = cas272;
  else if (cas270Menorq271 && cas270Mayorq272)
    this.modelo.doc.cuerpo.cs_id_273 = cas272;
  else if (cas270Iguala271 && cas270Mayorq272)
    this.modelo.doc.cuerpo.cs_id_273 = cas272;
  else if (cas270Iguala271 && cas270Menorq272)
    this.modelo.doc.cuerpo.cs_id_273 = cas270;
  else if (cas270Menorq271 && cas270Iguala272)
    this.modelo.doc.cuerpo.cs_id_273 = cas272;
  else if (cas270Iguala271 && cas270Iguala272)
    this.modelo.doc.cuerpo.cs_id_273 = cas272;

  const cas34 = this.modelo.doc.cuerpo.cs_id_34;
  const cas37 = this.modelo.doc.cuerpo.cs_id_37;
  const cas40 = this.modelo.doc.cuerpo.cs_id_40;
  const cas273 = this.modelo.doc.cuerpo.cs_id_273;
  const suma37_40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);

  //validar cambios
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, "0")) {
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma37_40, cas34)) {
      this.temporal41 = suma37_40;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, cas34)) {
      this.temporal41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma37_40, cas34)) {
      this.temporal41 = cas273;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, cas34)) {
      this.temporal41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
    }
  }
}

operacionCs274(): void {
    this.modelo.doc.cuerpo.cs_id_274 = "0";
    this.operacionCs115();
 
}

operacionCs290(): void {
  if (this.modelo.doc.cuerpo.cs_id_287 != null && this.modelo.doc.cuerpo.cs_id_288 != null && this.modelo.doc.cuerpo.cs_id_289 != null &&
    this.modelo.doc.cuerpo.cs_id_287 != "" && this.modelo.doc.cuerpo.cs_id_288 != "" && this.modelo.doc.cuerpo.cs_id_289 != "") {
    this.habilitaDependiente3 = false;
    if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 )
     {  
        this.habilitaDependiente5 = false;
       
     }
    this.contarDependientes();
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
  }
  else {
    this.habilitaDependiente2 = true;
  }
  this.operacionCs92();
}

operacionCs293(): void {
  if (this.modelo.doc.cuerpo.cs_id_290 != null && this.modelo.doc.cuerpo.cs_id_291 != null && this.modelo.doc.cuerpo.cs_id_292 != null &&
    this.modelo.doc.cuerpo.cs_id_290 != "" && this.modelo.doc.cuerpo.cs_id_291 != "" && this.modelo.doc.cuerpo.cs_id_292 != "") {
    this.habilitaDependiente4 = false;
    if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 )
     {  
        this.habilitaDependiente5 = false;
       
     }
    this.contarDependientes();
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
  }
  else {
    this.habilitaDependiente2 = true;
  }
  this.operacionCs92();
}
operacionCs295(): void {
  if (this.modelo.doc.cuerpo.cs_id_293 != null && this.modelo.doc.cuerpo.cs_id_294 != null && this.modelo.doc.cuerpo.cs_id_295 != null &&
    this.modelo.doc.cuerpo.cs_id_293 != "" && this.modelo.doc.cuerpo.cs_id_294 != "" && this.modelo.doc.cuerpo.cs_id_295 != "") {
    this.contarDependientes(); 
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    if(Number(this.modelo.doc.cuerpo.cs_id_355)>0 )
     {  
        this.habilitaDependiente5 = false;
       
     }
  }
  else {
    this.habilitaDependiente2 = true;
  }
  this.operacionCs92();
}
operacionCs358()
{
  const cas358=this.modelo.doc.cuerpo.cs_id_358;

  const cas242=this.modelo.doc.cuerpo.cs_id_242;
  const cas288=this.modelo.doc.cuerpo.cs_id_288;
  const cas291=this.modelo.doc.cuerpo.cs_id_291;
  const cas294=this.modelo.doc.cuerpo.cs_id_294;
  let boolBuscaDependientes=false;
  if (this.modelo.doc.cuerpo.cs_id_358 != null && this.modelo.doc.cuerpo.cs_id_358 != "") 
  {
    if(cas358==cas242) boolBuscaDependientes=true;
    else if(cas358==cas288) boolBuscaDependientes=true;
    else if(cas358==cas291) boolBuscaDependientes=true;
    else if(cas358==cas294) boolBuscaDependientes=true;
  }
  else
  {
    boolBuscaDependientes=true; 
  }
  if(!boolBuscaDependientes)
   this.dNotificacionServicio.mostrarDialogoError(MESSAGES.DEPENDIENTE);
  
   return boolBuscaDependientes;

}
operacionCs359()
{
  if (this.modelo.doc.cuerpo.cs_id_357 != null && this.modelo.doc.cuerpo.cs_id_358 != null && this.modelo.doc.cuerpo.cs_id_359 != null &&
    this.modelo.doc.cuerpo.cs_id_357 != "" && this.modelo.doc.cuerpo.cs_id_358 != "" && this.modelo.doc.cuerpo.cs_id_359 != "") {
    this.contarDependientes();
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
  }
  else {
    this.habilitaDependiente2 = true;
  }
  this.operacionCs92();

}

operacionCs296(): void {
    const resultado1090UVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, '1090', this.UVT);
    
    const camposSumaDivi = ['cs_id_107', 'cs_id_108'];
    const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
    const cas118=this.modelo.doc.cuerpo.cs_id_118;
    let letCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaDiv, cas118, true);
    
    letCasilla296 = this.dutilidades.deshacerFormatoMoneda(letCasilla296);
    if (Number(resultado1090UVT) < Number(letCasilla296)) {
      let resultadoCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, letCasilla296, resultado1090UVT);
      resultadoCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoCasilla296, '0.19');
      this.modelo.doc.cuerpo.cs_id_296 = this.dutilidades.redondearValorMoneda(resultadoCasilla296, true);
    }
    else {
      this.modelo.doc.cuerpo.cs_id_296 = '0';
    }
 
  this.operacionCs124();
}

operacionCs298(): void {
  let casilla303 ='0';
  let resultadoCasilla298 = '0';
  const cas118=this.modelo.doc.cuerpo.cs_id_118;
  const cas108=this.modelo.doc.cuerpo.cs_id_108;
  resultadoCasilla298 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas108, cas118);
  this.modelo.doc.cuerpo.cs_id_298 = resultadoCasilla298;
  if (this.modelo.doc.cuerpo.cs_id_43 != null && this.modelo.doc.cuerpo.cs_id_43 != '') {
    const casilla45 = this.modelo.doc.cuerpo.cs_id_45;
    const casilla43 = this.modelo.doc.cuerpo.cs_id_43;

    if (this.modelo.doc.cuerpo.cs_id_43 != '0')
      casilla303 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, casilla45, casilla43);
  }

  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, casilla303, "0.6"))
    this.booTopeindicativo = true;
  else this.booTopeindicativo = false;
  let dosDecCasilla303 =casilla303.substring(0,4);
  this.modelo.doc.cuerpo.cs_id_303 = dosDecCasilla303;
  
}

operacionCs316(): void {
  this.modelo.doc.cuerpo.cs_id_316 = 0;
 /*   const valoruvt72 = '72';
    const UVT72 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt72, this.UVT);
    if ((this.modelo.doc.cuerpo.cs_id_32 && this.modelo.doc.cuerpo.cs_id_32 != '0')
      || (this.modelo.doc.cuerpo.cs_id_43 && this.modelo.doc.cuerpo.cs_id_43 != '0')) {
      if (this.modelo.doc.cuerpo.cs_id_242 && this.modelo.doc.cuerpo.cs_id_242 != '0') {
        this.modelo.doc.cuerpo.cs_id_316 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_316, UVT72);
      }
      if (this.modelo.doc.cuerpo.cs_id_288 && this.modelo.doc.cuerpo.cs_id_288 != '0') {
        this.modelo.doc.cuerpo.cs_id_316 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_316, UVT72);
      }
      if (this.modelo.doc.cuerpo.cs_id_291 && this.modelo.doc.cuerpo.cs_id_291 != '0') {
        this.modelo.doc.cuerpo.cs_id_316 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_316, UVT72);
      }
      if (this.modelo.doc.cuerpo.cs_id_294 && this.modelo.doc.cuerpo.cs_id_294 != '0') {
        this.modelo.doc.cuerpo.cs_id_316 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_316, UVT72);
      }
    }
    if (this.modelo.doc.cuerpo.cs_id_335 && this.modelo.doc.cuerpo.cs_id_335 == '1') {
      this.modelo.doc.cuerpo.cs_id_316 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.modelo.doc.cuerpo.cs_id_316, UVT72);
    }
  */
}
operacionCs139(): void {
  this.modelo.doc.cuerpo.cs_id_139 = 0;
    const valoruvt72 = '72';
    const UVT72 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt72, this.UVT);
    if (this.modelo.doc.cuerpo.cs_id_355 && this.modelo.doc.cuerpo.cs_id_355 != '0')
     {
      if (this.modelo.doc.cuerpo.cs_id_242 && this.modelo.doc.cuerpo.cs_id_242 != '') {
        this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
      }
      if (this.modelo.doc.cuerpo.cs_id_288 && this.modelo.doc.cuerpo.cs_id_288 != '') {
        this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
      }
      if (this.modelo.doc.cuerpo.cs_id_291 && this.modelo.doc.cuerpo.cs_id_291 != '') {
        this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
      }
      if (this.modelo.doc.cuerpo.cs_id_294 && this.modelo.doc.cuerpo.cs_id_294 != '') {
        this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
      }
    }
 //   if (this.modelo.doc.cuerpo.cs_id_335 && this.modelo.doc.cuerpo.cs_id_335 == '1') {
  //    this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
  //  }

    const camposSumaF = ['cs_id_42', 'cs_id_57','cs_id_41','cs_id_53'];
    let resultadoCamposSumaF = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaF, true);
    let valorRedondeado_42_57 = this.dutilidades.redondearValorMoneda(resultadoCamposSumaF, true);
    
    let cas139 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_139, true);
    const mayorque2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas139, valorRedondeado_42_57);
    if (mayorque2) this.modelo.doc.cuerpo.cs_id_139 = valorRedondeado_42_57;
    else this.modelo.doc.cuerpo.cs_id_139 = cas139;
  
}

operacionCs980(): void {
    this.modelo.doc.pie.cs_id_980 = "0";
}

//Operaciones de operaciones
operacionCs32_33(): void {
  console.log("ini operaciones");
  
  //casilla 32 se divide en 355 y 356 y se dehabilita 2024
  const cas355 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_355);
  const cas356 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_356);
  const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas355, cas356, true);
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
  this.modelo.doc.cuerpo.cs_id_32 = valorRedondeado;

  this.operacionCs270();
  this.operacionCs34();
  /*this.operacionCs270();
  this.operacionCs34();
  this.operacionCs270();
  this.operacionCs34();
  this.operacionCs270();
  this.operacionCs34();*/
  console.log("fin operaciones");
}

operacionCs43_44_45(): void {
  this.operacionCs270();
  this.operacionCs46();
  this.operacionCs298();
}

operacionCs58_59_60(): void {
  this.operacionCs270();
  this.operacionCs61();
}

operacionCs74_75_76(): void {
  this.operacionCs270();
  this.operacionCs78();
}

//Otras operaciones de cambio
ingresoCs121(): void {
  this.calcularCas121 = false;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
  this.modelo.doc.cuerpo.cs_id_121 = valorRedondeado;
  this.operacionCs120();
}

cambioUsarioCs127(): void {
  const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121, true);
  const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125, true);
  const cas126 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_126, true);
  const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas121, cas125, true);
  const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
  const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
  if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas126, resultadoOperacion)) {
    this.modelo.doc.cuerpo.cs_id_126 = valorRedondeado;
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 126 no puede ser menor a la casilla 121 - casilla 125");
  }
  this.operacionCs127Cambio();
 // this.operacionCs129();
}

operacionCs127Cambio(): void {
  const cas115 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_115);
  const cas127 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_127);

  let porcentajeTopeMax = "0";
  let porcentajeTopeMin = "0";

    porcentajeTopeMin = "0.15";
    porcentajeTopeMax = "0.2";
  
  const cas115DiezPorciento = this.dutilidades.redondearValorMoneda(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, porcentajeTopeMin));
  const cas115MaxTopePorciento = this.dutilidades.redondearValorMoneda(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, porcentajeTopeMax));

  if (!(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas127, cas115DiezPorciento) &&
    (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas127, cas115MaxTopePorciento)))) {
    this.modelo.doc.cuerpo.cs_id_127 = cas115MaxTopePorciento;
    this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 127 debe estar en un rango del " + this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentajeTopeMin, "100") + "% al " + this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentajeTopeMax, "100") + "% de la casilla 115");
  }
  this.operacionCs129();
}
  public validarDisabledPreguntas(){
    let preguntas = [];    
    preguntas.push({casilla: "245", valor: this.modelo.doc.cuerpo.cs_id_246, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "247", valor: this.modelo.doc.cuerpo.cs_id_248, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "249", valor: this.modelo.doc.cuerpo.cs_id_250, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "251", valor: this.modelo.doc.cuerpo.cs_id_252, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "253", valor: this.modelo.doc.cuerpo.cs_id_254, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "282", valor: this.modelo.doc.cuerpo.cs_id_281, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "279", valor: this.modelo.doc.cuerpo.cs_id_280, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "255", valor: this.modelo.doc.cuerpo.cs_id_256, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74});
    preguntas.push({casilla: "277", valor: this.modelo.doc.cuerpo.cs_id_278, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74});
    preguntas.push({casilla: "275", valor: this.modelo.doc.cuerpo.cs_id_276, casillaControl: "58", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_58});
    

    for(let pregunta of preguntas){
      let cas = Number(pregunta.casilla) + 1;
      let casillaElemento = document.querySelector('#cs_id_'+cas);
      if(casillaElemento){
        if(pregunta.valor=="0" || pregunta.valor=="" || pregunta.valor == null){
          casillaElemento.setAttribute('disabled', 'true');    
        }else{
          casillaElemento.removeAttribute('disabled');
        }        
      }
    }    
  }

  public validarPreguntas(definitivo?:boolean):void{    
      if (this.modelo.doc.cuerpo.cs_id_24 == "" || this.modelo.doc.cuerpo.cs_id_24 == null){
        this.dNotificacionServicio.mostrarDialogoInformacion("Diligencie la actividad económica seleccionando uno de los elementos en la lista de la casilla 24");
        return;
      }
    if(this.booFraccion && this.booTopeindicativo)
    {
      let validaindicativo : Boolean = this.modelo.doc.cuerpo['cs_id_303'];
      let stringIndicativo : string = this.modelo.doc.cuerpo['cs_id_303'];
      if(!validaindicativo)
      {
        this.dNotificacionServicio.mostrarDialogoInformacion("Superó tope indicativo relativo al art. 336-1 del E.T. marque casilla 303");
        return;
      }
    }
    let validacion = true;
    let mensaje = "";
    let preguntas = [];    
    preguntas.push({casilla: "245", valor: this.modelo.doc.cuerpo.cs_id_246, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "247", valor: this.modelo.doc.cuerpo.cs_id_248, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "249", valor: this.modelo.doc.cuerpo.cs_id_250, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "251", valor: this.modelo.doc.cuerpo.cs_id_252, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "253", valor: this.modelo.doc.cuerpo.cs_id_254, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "282", valor: this.modelo.doc.cuerpo.cs_id_281, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "279", valor: this.modelo.doc.cuerpo.cs_id_280, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32});
    preguntas.push({casilla: "255", valor: this.modelo.doc.cuerpo.cs_id_256, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74});
    preguntas.push({casilla: "277", valor: this.modelo.doc.cuerpo.cs_id_278, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74});
    preguntas.push({casilla: "275", valor: this.modelo.doc.cuerpo.cs_id_276, casillaControl: "58", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_58});

    for(let pregunta of preguntas){
      if(pregunta.valor=="" || pregunta.valor=="0" ||pregunta.valor == null ){
        this.modelo.doc.cuerpo['cs_id_'+pregunta.casilla] = "0";
      }else if(pregunta.casilla != "27" && pregunta.valor == "1" && this.modelo.doc.cuerpo['cs_id_'+(Number(pregunta.casilla)+1)] == "0"){
        mensaje = "Debo agregar un valor en la casilla " + (Number(pregunta.casilla)+1) + ". Por favor verifique.";
        validacion = false;
        break;        
      }else if(pregunta.valor == "1" && pregunta.valorCasillaControl == "0"){
        mensaje = "no puede contestar sí en la pregunta de la casilla " + pregunta.casilla + "por que, el valor de la casilla " + pregunta.casillaControl + " es 0. Por favor verifique.";
        validacion = false;
        break;        
      }
    }

    let camposSuma = ['cs_id_246','cs_id_248','cs_id_250','cs_id_525','cs_id_254','cs_id_256','cs_id_276','cs_id_278','cs_id_280','cs_id_281'];
    let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma,true);
    let cas138 = this.modelo.doc.cuerpo.cs_id_138;
    //sumar 31,38,49 y comparar contra suma de preguntas
    let camposSumaIngresos = ['cs_id_32','cs_id_43','cs_id_58','cs_id_74'];
    let resultadoSumaIngresos = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaIngresos, true);    
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma, resultadoSumaIngresos)){
      mensaje = "La sumatoria de los valores reportados en las preguntas no puede superar la suma de los ingresos (cas. 32 + cas. 43 + cas. 58 + cas. 74)";
      validacion = false;
    }

    //if(this.temporal41 && this.temporal53 && this.temporal69 && this.temporal86){
      let cas41 = this.modelo.doc.cuerpo.cs_id_41;
      let cas53 = this.modelo.doc.cuerpo.cs_id_53;
      let cas69 = this.modelo.doc.cuerpo.cs_id_69;
      let cas86 = this.modelo.doc.cuerpo.cs_id_86;
      let cas37 = this.modelo.doc.cuerpo.cs_id_37;
      let cas40 = this.modelo.doc.cuerpo.cs_id_40;
      let cas49 = this.modelo.doc.cuerpo.cs_id_49;
      let cas52 = this.modelo.doc.cuerpo.cs_id_52;
      let cas65 = this.modelo.doc.cuerpo.cs_id_65;
      let cas68 = this.modelo.doc.cuerpo.cs_id_68;
      let cas82 = this.modelo.doc.cuerpo.cs_id_82;
      let cas85 = this.modelo.doc.cuerpo.cs_id_85;

      let suma37_40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);
      let suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);
      let suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true);
      let suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true);


      this.temporal41 =  this.dutilidades.redondearValorMoneda(this.temporal41);
      this.temporal53 =  this.dutilidades.redondearValorMoneda(this.temporal53);
      this.temporal69 =  this.dutilidades.redondearValorMoneda(this.temporal69);
      this.temporal86 =  this.dutilidades.redondearValorMoneda(this.temporal86);

      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, "0")  && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas41, this.temporal41)){
        mensaje = "SEÑOR CONTRIBUYENTE LOS VALORES HAN CAMBIADO, RECALCULE EL VALOR DE LA CASILLA 41, DIGITANDO NUEVAMENTE EL VALOR DE ALGUNA DE LAS CASILLAS 35, 36, 38, 39. VALOR SUGERIDO DE LA CASILLA 41 ES " + this.temporal41;
        validacion = false;
      }else if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, "0")  &&!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas53, this.temporal53)){
        mensaje = "SEÑOR CONTRIBUYENTE LOS VALORES HAN CAMBIADO, RECALCULE EL VALOR DE LA CASILLA 53, DIGITANDO NUEVAMENTE EL VALOR DE ALGUNA DE LAS CASILLAS 47, 48, 50, 51. VALOR SUGERIDO DE LA CASILLA 53 ES " + this.temporal53;
        validacion = false;
      }else if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, "0")  && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas69, this.temporal69)){
        mensaje = "SEÑOR CONTRIBUYENTE LOS VALORES HAN CAMBIADO, RECALCULE EL VALOR DE LA CASILLA 69, DIGITANDO NUEVAMENTE EL VALOR DE ALGUNA DE LAS CASILLAS 63, 64, 66, 67. VALOR SUGERIDO DE LA CASILLA 69 ES " + this.temporal69;
        validacion = false;
      }else if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, "0")  && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas86, this.temporal86)){
        mensaje = "SEÑOR CONTRIBUYENTE LOS VALORES HAN CAMBIADO, RECALCULE EL VALOR DE LA CASILLA 86, DIGITANDO NUEVAMENTE EL VALOR DE ALGUNA DE LAS CASILLAS 80, 81, 83, 84. VALOR SUGERIDO DE LA CASILLA 86 ES " + this.temporal86;
        validacion = false;
      }
    /*}else{
      this.temporal41 = this.modelo.doc.cuerpo.cs_id_41;
      this.temporal53 = this.modelo.doc.cuerpo.cs_id_53;
      this.temporal69 = this.modelo.doc.cuerpo.cs_id_69;
      this.temporal86 = this.modelo.doc.cuerpo.cs_id_86;
    }*/

    this.modelo.doc.cuerpo.cs_id_117 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_117);
    this.modelo.doc.cuerpo.cs_id_119 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_119);
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.modelo.doc.cuerpo.cs_id_130 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_130);
    this.modelo.doc.cuerpo.cs_id_271 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_271);
    this.modelo.doc.cuerpo.cs_id_272 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_272);

    this.modelo.doc.pie.cs_id_980 = this.dutilidades.deshacerFormatoMoneda(this.dutilidades.redondearValorMoneda(this.modelo.doc.pie.cs_id_980));
    this.operacionCs270();
    if(validacion){
      this.cambioFirma = false;
      if(definitivo){
          this.validarDeclaSugeridaGuardarDefinitivo();
        }else{
          this.validarDeclaSugeridaGuardar(); 
        }      
    }else{
      this.dNotificacionServicio.mostrarDialogoError(mensaje);
    }
    
  }
  private recalcularFormulario(): void {
    // let precalculo = this.dNotificacionServicio.mostrarDialogoCarga();
     
    // precalculo.beforeClose().subscribe(result => {
 
     this.boolfinal=true;
     this.operacionCs31();
     
 
     //RENTAS DE TRABAJO
     this.operacionCs32_33();
     //HONORARIOS
     this.operacionCs46();
     //CAPITAL
     this.operacionCs61();
     //RENTA NO LABORAL
     this.operacionCs78();
  //   });
  //   precalculo.close();
   //  this.operacionCs106();
   //  this.operacionCs115();
    // this.operacionCs119(true);
    // this.operacionCs120();
    this.boolfinal=false;
 
   }

  public convertirPesosUvt(valorPesos){
    valorPesos=this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.UVT);
    valorOperacion = valorOperacion.toFormat();
    let punto = valorOperacion.indexOf(".") + 1;
    if((punto > 0)&&(valorOperacion.length - punto) > 2)
    valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  } 

  
  public cargando(){
  }

  protected pagarFormulario_INIT(){
    //id, anio, periodo, modo, item

    console.log("anio",);
    console.log("periodo",);
    console.log("modo",);

    let arrayButtons = [
        {text: 'SI/YES', value: "COP", mdClass: 'warn', disabled: false} ,
        {text: 'NO', value: "USD", mdClass: 'warn', disabled: false}  
    ];
    let id = this.modelo.doc.cab.cs_id_4;
    let dialog_carga = this.dNotificacionServicio.mostrarDialogoPersonalizado('<b>ES:</b> ¿Realizará el pago en pesos colombianos? </br> <b>EN:</b> Will you make the payment in Colombian pesos?', "", "",arrayButtons,null,null,null);
    
        dialog_carga.afterClosed().subscribe(
            result => {
                if(result==="USD"){
                    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                    let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPagoExterior(id);
                    observableServicio.subscribe(
                        res => {
                            precarga.close();
                            let liquidacion = <DLiquidacionReciboExterior>res;                                
                            
                        },
                        error => {
                            precarga.close();
                            console.log('Servicio generar liquidacion del reciBo de pago ejecutado con error');
                            this.dNotificacionServicio.mostrarDialogoError('No es posible generar el recibo de pago');                     
                        }
                    );
                }
                if(result==="COP"){                        
                   // this.pagarFormulario(null,null,true);
                }
        }
    ); 

  }

    
  protected eventDataFormulario(data: any) {
    //throw new Error('Method not implemented.');
  }
public operPorcenDividendos(casilla:string)
{
  let porcentaje:string = this.modelo.doc.cuerpo[casilla];
  let booporcentaje:boolean=false;
  for (let tipoPorcen of this.porcDividendos){
    if (porcentaje==tipoPorcen) {
      booporcentaje=true;
      break;
    }
    else{
      booporcentaje=false;
    }
  }
  if(!booporcentaje){
    this.dNotificacionServicio.mostrarDialogoError("El valor "+ porcentaje +" Debe coincidir con los valores porcentuales" );
    this.modelo.doc.cuerpo[casilla] = 0;
  }

}
public operacionDividendos(tarifa:string,base:string,impuesto:string)
{
  let porcentaje:string = this.modelo.doc.cuerpo[tarifa];
  let cienporciento='100';
  
  porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, porcentaje, cienporciento);
  let basemultiplica:string = this.modelo.doc.cuerpo[base];
  basemultiplica = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, basemultiplica, porcentaje);
  this.modelo.doc.cuerpo[impuesto] = basemultiplica;
  this.operacionCs108();
  this.operacionCs121();
  this.operacionCs97();
}
  public dividendosOtros(repeteciones:number)
  {
    let cuenta300: number =304;
    this.strDividendosOtros ='<div fxLayout="row">';
    for(let cuenta=1; cuenta <= repeteciones; cuenta++)
    {
      this.strDividendosOtros +='<div fxFlex><label for="cs_id_'+cuenta300+'">'+cuenta300+'. Tarifa '+cuenta+':  </label><input type="text" id="cs_id_'+cuenta300+'" name="cs_id_'+cuenta300+'" class="inputs-form number-value" formatoMoneda [redondear]="true" [maxLength]="18" #focusable'+cuenta300+' (blur)="operacionCs106()" [(ngModel)]="modelo.doc.cuerpo.cs_id_'+cuenta300+'" (keyup.enter)="cambioFocoCasillas($event, ';
      cuenta300++;
      this.strDividendosOtros +='focusable'+cuenta300+')" [mostrarAyuda]="modelo.doc.cab.cs_id_1"> </div> <span class="separator-inputs-form"></span> <div fxFlex> <label for="cs_id_'+cuenta300+'">'+cuenta300+'. Base '+cuenta+':  </label> <input type="text" id="cs_id_'+cuenta300+'" name="cs_id_'+cuenta300+'" class="inputs-form number-value" formatoMoneda [redondear]="true" [maxLength]="18" #focusable'+cuenta300+' (blur)="operacionCs106()" [(ngModel)]="modelo.doc.cuerpo.cs_id_'+cuenta300+'" (keyup.enter)="cambioFocoCasillas($event, ';
      cuenta300++;
      this.strDividendosOtros +='focusable'+cuenta300+')" [mostrarAyuda]="modelo.doc.cab.cs_id_1"> </div> <span class="separator-inputs-form"></span> <div fxFlex [mostrarAyuda]="modelo.doc.cab.cs_id_1" [idChild]="cs_id_76"> <label for="'+cuenta300+'">'+cuenta300+'. Impuesto dividendo '+cuenta+': </label> <input 	type="text" id="cs_id_'+cuenta300+'" name="cs_id_'+cuenta300+'" class="inputs-form number-value" disabled #focusable'+cuenta300+' [(ngModel)]="modelo.doc.cuerpo.cs_id_'+cuenta300+'" [mostrarAyuda]="modelo.doc.cab.cs_id_1">';
      
    }
    this.strDividendosOtros +='</div>'; 
  }
  public mensajeCs108()
  { 
    //this.operacionCs121();
    if(this.booFraccion)
    {
      this.dNotificacionServicio.mostrarDialogoInformacion('Para diligenciar el valor de la casilla 108 debe incluir los valores según lo requiera en las casillas  304, 305, 307, 308, 310, 311, 313, 314,  318, 319,  321, 322, 324, 325, 327, 328,  330,  331, 333,  334, en la siguiente pestaña');  
      return;
    }
  }
  protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
    let valores = [];
    for (let i in campos) {
        if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
            let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
            valores.push(valor);
            //valores.push(modelo.doc.cuerpo[campos[i]]);
        } else {
            valores.push('0');
        }
    }
    return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
}

calcularTotalIngresos() {
  //Total ingresos
  const camposSuma = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74', 'cs_id_99', 'cs_id_104', 'cs_id_107', 'cs_id_108', 'cs_id_109', 'cs_id_111'];
  this.totalIngresos = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
}

  //calculo de sanción por extemporaneidad
  sancionExtemporaneidad() {
    const uvt10   = "424000";
    const uvt2500 = "106030000";
    this.modelo.doc.cuerpo.cs_id_136 = "0";
    this.operacionCs137();
    //total impuesto a cargo
    const cas130 = this.modelo.doc.cuerpo.cs_id_130;
    //saldo a favor
    const cas138 = this.modelo.doc.cuerpo.cs_id_138;
    //patrimonio liquido año anterior
    const cas339 = this.modelo.doc.cuerpo.cs_id_339;
    //gradualidad de la sancion
    const cas340 = this.modelo.doc.cuerpo.cs_id_340;

    //fecha de vencimiento
    const nFecVencimiento = Number(this.modelo.doc.cuerpo.cs_id_341);

    //numero de meses o fracción de año
    const dFechaHoy = new Date();
    const nFechaHoy = Number(dFechaHoy.toISOString().substring(0,10).split("-").join(""));
    const meses = Math.ceil((nFechaHoy-nFecVencimiento)/100).toString();

    let topeSancion = "0";
    let sancion = uvt10;
    
    
    //Tiene impuesto a cargo
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas130,"0")) {
	
        const factor5xCienxMes = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,meses,"0.05");

        sancion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas130,factor5xCienxMes);
      
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,sancion,cas130)) {
           sancion = cas130;
        }
      
    //No tiene impuesto a cargo
    } else {

      let dosVecesC138 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas138,"2");		

      //Tiene ingresos brutos
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.totalIngresos,"0")) {
      
        const factor05xCienxMes = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,meses,"0.005");
        const ingresos05xCienxMes = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.totalIngresos,factor05xCienxMes);
        const ingresos5xCiento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.totalIngresos,"0.05");
      
        //Si tiene saldo a favor
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas138,"0")) {
        
          //Calcular tope	
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,ingresos5xCiento,dosVecesC138)) {
            topeSancion = ingresos5xCiento;
          } else {
            topeSancion = dosVecesC138;
          }

          
        //No tiene saldo a favor
        } else {
        
          //Calcular tope	
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,ingresos5xCiento,uvt2500)) {
            topeSancion = ingresos5xCiento;
          } else {
            topeSancion = uvt2500;
          }
        }

        //Determinar sancion
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,ingresos05xCienxMes,topeSancion)) {
          sancion = ingresos05xCienxMes;
        } else {
          sancion = topeSancion;
        }
      
      //No tiene ingresos brutos
      } else {
	  
    	const factor1xCienxMes = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,meses,"0.01");
      
        //Tiene patrimonio liquido año anterior
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas339,"0")) {

          const patLiquido1xCienxMes = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas339,factor1xCienxMes);
          const patLiquido10xCiento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas339,"0.1");

          //Si tiene saldo a favor
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas138,"0")) {
          
            //Calcular tope	
            if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,patLiquido10xCiento,dosVecesC138)) {
              topeSancion = patLiquido10xCiento;
            } else {
              topeSancion = dosVecesC138;
            }
          
          // No tiene saldo a favor
          } else {
            
            //Calcular tope	
            if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,patLiquido10xCiento,uvt2500)) {
              topeSancion = patLiquido10xCiento;
            } else {
              topeSancion = uvt2500;
            }
          }
          
          //Determinar sancion
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,patLiquido1xCienxMes,topeSancion)) {
            sancion = patLiquido1xCienxMes;
          } else {
            sancion = topeSancion;
          }

          
        }
      }
    } 

    sancion = this.dutilidades.redondearValorMoneda(sancion);
    //gradualidad de la sancion
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas340,"1") || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas340,"2")) {  
      sancion =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,sancion,"0.5");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas340,"3")) {
      sancion =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,sancion,"0.75");
    }

    sancion = this.dutilidades.redondearValorMoneda(sancion);
    //Sancion minima
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE,sancion,uvt10)) {
      sancion = uvt10;
    }
    
    sancion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, sancion, this.modelo.doc.cuerpo.cs_id_431);
    this.modelo.doc.cuerpo.cs_id_136 = sancion;

    this.operacionCs137();
  }
  contarDependientes()
  {
    this.cuentadependientes=0;
    if( this.modelo.doc.cuerpo.cs_id_241 != null && this.modelo.doc.cuerpo.cs_id_242 != null  && this.modelo.doc.cuerpo.cs_id_244 != null &&
      this.modelo.doc.cuerpo.cs_id_241 != "" && this.modelo.doc.cuerpo.cs_id_242 != ""  && this.modelo.doc.cuerpo.cs_id_244 != "" )
      {
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_287 != null && this.modelo.doc.cuerpo.cs_id_288 != null && this.modelo.doc.cuerpo.cs_id_289 != null &&
      this.modelo.doc.cuerpo.cs_id_287 != "" && this.modelo.doc.cuerpo.cs_id_288 != "" && this.modelo.doc.cuerpo.cs_id_289 != "") 
      {
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_290 != null && this.modelo.doc.cuerpo.cs_id_291 != null && this.modelo.doc.cuerpo.cs_id_292 != null &&
        this.modelo.doc.cuerpo.cs_id_290 != "" && this.modelo.doc.cuerpo.cs_id_291 != "" && this.modelo.doc.cuerpo.cs_id_292 != "") 
      {
        
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_293 != null && this.modelo.doc.cuerpo.cs_id_294 != null && this.modelo.doc.cuerpo.cs_id_295 != null &&
        this.modelo.doc.cuerpo.cs_id_293 != "" && this.modelo.doc.cuerpo.cs_id_294 != "" && this.modelo.doc.cuerpo.cs_id_295 != "") 
      {
          this.cuentadependientes++;
          
       }
     }
  


}


// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/services/formulario.servicio.ts